export const IconPack = {
  filter_icon: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 8.32624C20 9.97193 16.4183 11.306 12 11.306C7.58172 11.306 4 9.97193 4 8.32624M20 8.32624C20 12.0778 17.9318 15.2897 15 16.6158V19.0176C15 19.7701 14.572 20.458 13.8944 20.7945L11.8944 21.7877C10.5646 22.4481 9 21.4877 9 20.0109V16.6158C6.06817 15.2897 4 12.0778 4 8.32624M20 8.32624C20 7.38522 18.8289 6.54609 17 6M4 8.32624C4 7.38522 5.17107 6.54609 7 6M14 5V7M10 7V8M10 2V4"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  logout: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1222_37453)">
        <path
          d="M9.5 10.5V12.5C9.5 12.7652 9.39464 13.0196 9.20711 13.2071C9.01957 13.3946 8.76522 13.5 8.5 13.5H1.5C1.23478 13.5 0.98043 13.3946 0.792893 13.2071C0.605357 13.0196 0.5 12.7652 0.5 12.5V1.5C0.5 1.23478 0.605357 0.98043 0.792893 0.792893C0.98043 0.605357 1.23478 0.5 1.5 0.5H8.5C8.76522 0.5 9.01957 0.605357 9.20711 0.792893C9.39464 0.98043 9.5 1.23478 9.5 1.5V3.5"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.5 7H13.5"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.5 5L13.5 7L11.5 9"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1222_37453">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  public_profile_package: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1222_30262)">
        <path
          d="M3.48048 10.5327C4.11084 10.5327 4.62184 10.0217 4.62184 9.39137C4.62184 8.76101 4.11084 8.25 3.48048 8.25C2.85012 8.25 2.33911 8.76101 2.33911 9.39137C2.33911 10.0217 2.85012 10.5327 3.48048 10.5327Z"
          stroke="var(--public-profile-service-color)"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.42505 13.4787C1.42868 13.1307 1.52046 12.7893 1.6918 12.4864C2.05287 11.8481 2.74633 11.4428 3.47951 11.4412C4.21269 11.4428 4.90615 11.8481 5.26722 12.4864C5.43856 12.7893 5.53033 13.1307 5.53397 13.4787"
          stroke="var(--public-profile-service-color)"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.5254 10.5327C11.1558 10.5327 11.6668 10.0217 11.6668 9.39137C11.6668 8.76101 11.1558 8.25 10.5254 8.25C9.89504 8.25 9.38403 8.76101 9.38403 9.39137C9.38403 10.0217 9.89504 10.5327 10.5254 10.5327Z"
          stroke="var(--public-profile-service-color)"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.46997 13.4787C8.47361 13.1307 8.56538 12.7893 8.73672 12.4864C9.09779 11.8481 9.79125 11.4428 10.5244 11.4412C11.2576 11.4428 11.9511 11.8481 12.3121 12.4864C12.4835 12.7893 12.5753 13.1307 12.5789 13.4787"
          stroke="var(--public-profile-service-color)"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.999 4.04708C7.58741 4.04708 8.06441 3.57008 8.06441 2.98167C8.06441 2.39326 7.58741 1.91626 6.999 1.91626C6.41059 1.91626 5.93359 2.39326 5.93359 2.98167C5.93359 3.57008 6.41059 4.04708 6.999 4.04708Z"
          stroke="var(--public-profile-service-color)"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.00781 6.71826C5.01134 6.38085 5.10032 6.04985 5.26645 5.75615C5.61655 5.13724 6.28893 4.74422 6.99982 4.74268C7.71071 4.74422 8.38309 5.13724 8.73319 5.75615C8.89932 6.04984 8.98831 6.38085 8.99183 6.71826"
          stroke="var(--public-profile-service-color)"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.7818 0.544922H2.21823C1.82156 0.544922 1.5 0.866486 1.5 1.26315V6C1.5 6.39667 1.82156 6.71823 2.21823 6.71823H11.7818C12.1784 6.71823 12.5 6.39667 12.5 6V1.26315C12.5 0.866486 12.1784 0.544922 11.7818 0.544922Z"
          stroke="var(--public-profile-service-color)"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1222_30262">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  profile_management_package: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1222_36841)">
        <path
          d="M5.23004 2.25L5.66004 1.14C5.73256 0.952064 5.86015 0.790411 6.02609 0.676212C6.19204 0.562014 6.3886 0.500595 6.59004 0.5H7.41004C7.61148 0.500595 7.80805 0.562014 7.97399 0.676212C8.13994 0.790411 8.26752 0.952064 8.34004 1.14L8.77004 2.25L10.23 3.09L11.41 2.91C11.6065 2.88333 11.8065 2.91567 11.9846 3.00292C12.1626 3.09017 12.3107 3.22838 12.41 3.4L12.81 4.1C12.9125 4.27435 12.9598 4.47568 12.9455 4.67742C12.9312 4.87916 12.8561 5.07183 12.73 5.23L12 6.16V7.84L12.75 8.77C12.8761 8.92817 12.9512 9.12084 12.9655 9.32258C12.9798 9.52432 12.9325 9.72565 12.83 9.9L12.43 10.6C12.3307 10.7716 12.1826 10.9098 12.0046 10.9971C11.8265 11.0843 11.6265 11.1167 11.43 11.09L10.25 10.91L8.79004 11.75L8.36004 12.86C8.28752 13.0479 8.15994 13.2096 7.99399 13.3238C7.82805 13.438 7.63148 13.4994 7.43004 13.5H6.59004C6.3886 13.4994 6.19204 13.438 6.02609 13.3238C5.86015 13.2096 5.73256 13.0479 5.66004 12.86L5.23004 11.75L3.77004 10.91L2.59004 11.09C2.39356 11.1167 2.19358 11.0843 2.01552 10.9971C1.83747 10.9098 1.68937 10.7716 1.59004 10.6L1.19004 9.9C1.08754 9.72565 1.04032 9.52432 1.0546 9.32258C1.06888 9.12084 1.144 8.92817 1.27004 8.77L2.00004 7.84V6.16L1.25004 5.23C1.124 5.07183 1.04888 4.87916 1.0346 4.67742C1.02032 4.47568 1.06754 4.27435 1.17004 4.1L1.57004 3.4C1.66937 3.22838 1.81747 3.09017 1.99552 3.00292C2.17358 2.91567 2.37356 2.88333 2.57004 2.91L3.75004 3.09L5.23004 2.25ZM5.00004 7C5.00004 7.39556 5.11734 7.78224 5.3371 8.11114C5.55687 8.44004 5.86922 8.69638 6.23467 8.84776C6.60013 8.99913 7.00226 9.03874 7.39022 8.96157C7.77818 8.8844 8.13455 8.69392 8.41426 8.41421C8.69396 8.13451 8.88444 7.77814 8.96161 7.39018C9.03878 7.00222 8.99918 6.60009 8.8478 6.23463C8.69643 5.86918 8.44008 5.55682 8.11118 5.33706C7.78228 5.1173 7.3956 5 7.00004 5C6.46961 5 5.9609 5.21071 5.58583 5.58579C5.21076 5.96086 5.00004 6.46957 5.00004 7Z"
          stroke="var(--profile-management-color)"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1222_36841">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  user_profile: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1222_38055)">
        <path
          d="M7 8C8.38071 8 9.5 6.88071 9.5 5.5C9.5 4.11929 8.38071 3 7 3C5.61929 3 4.5 4.11929 4.5 5.5C4.5 6.88071 5.61929 8 7 8Z"
          stroke="var(--accent-color)"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.72998 11.8999C3.17622 11.1674 3.80339 10.562 4.55119 10.142C5.29899 9.72186 6.14227 9.50122 6.99998 9.50122C7.85769 9.50122 8.70097 9.72186 9.44877 10.142C10.1966 10.562 10.8237 11.1674 11.27 11.8999"
          stroke="var(--accent-color)"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7 13.5C10.5899 13.5 13.5 10.5899 13.5 7C13.5 3.41015 10.5899 0.5 7 0.5C3.41015 0.5 0.5 3.41015 0.5 7C0.5 10.5899 3.41015 13.5 7 13.5Z"
          stroke="var(--accent-color)"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1222_38055">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  duplicated_profile: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.4381 7.99993C9.54886 7.99993 8.828 7.27907 8.828 6.38986C8.828 5.50064 9.54886 4.77979 10.4381 4.77979C11.3273 4.77979 12.0482 5.50064 12.0482 6.38986C12.0482 7.27907 11.3273 7.99993 10.4381 7.99993Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.09888 10.4851C8.32067 10.2507 8.57732 10.05 8.86091 9.89066C9.34252 9.62013 9.88562 9.47803 10.438 9.47803C10.9904 9.47803 11.5335 9.62013 12.0151 9.89066C12.2234 10.0077 12.4172 10.147 12.5933 10.3057"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.22894 7.48328C4.12704 7.48328 3.23376 6.59 3.23376 5.4881C3.23376 4.38619 4.12704 3.49292 5.22894 3.49292C6.33085 3.49292 7.22412 4.38619 7.22412 5.4881C7.22412 6.59 6.33085 7.48328 5.22894 7.48328Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.96655 13.1811C8.86704 11.9894 8.57009 11.2058 8.40728 10.9299C8.06066 10.3406 7.57351 9.85349 6.99265 9.51551C6.4118 9.17752 5.75676 9 5.09053 9C4.4243 9 3.76929 9.17752 3.18843 9.51551C2.72462 9.78539 2.32055 10.1503 2.00006 10.5865L1.79688 10.8906"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 13.5C3.41015 13.5 0.5 10.5899 0.5 7C0.5 3.41015 3.41015 0.5 7 0.5C10.5899 0.5 13.5 3.41015 13.5 7C13.5 10.5899 10.5899 13.5 7 13.5Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  outlinedSearch: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.3752 8.74999C14.3752 9.48868 14.2297 10.2201 13.9471 10.9026C13.6644 11.585 13.25 12.2051 12.7277 12.7275C12.2054 13.2498 11.5853 13.6641 10.9028 13.9468C10.2204 14.2295 9.48892 14.375 8.75024 14.375C8.01155 14.375 7.2801 14.2295 6.59764 13.9468C5.91519 13.6641 5.29509 13.2498 4.77276 12.7275C4.25043 12.2051 3.8361 11.585 3.55342 10.9026C3.27073 10.2201 3.12524 9.48868 3.12524 8.74999C3.12524 7.25815 3.71787 5.82741 4.77276 4.77252C5.82765 3.71763 7.25839 3.12499 8.75024 3.12499C10.2421 3.12499 11.6728 3.71763 12.7277 4.77252C13.7826 5.82741 14.3752 7.25815 14.3752 8.74999ZM13.3502 14.675C11.8432 15.845 9.94695 16.3966 8.04749 16.2177C6.14803 16.0387 4.38817 15.1426 3.12617 13.7117C1.86418 12.2809 1.19493 10.4229 1.25466 8.51593C1.31439 6.609 2.09861 4.7965 3.44768 3.44744C4.79675 2.09837 6.60924 1.31414 8.51618 1.25441C10.4231 1.19468 12.2811 1.86394 13.712 3.12593C15.1428 4.38792 16.039 6.14778 16.2179 8.04724C16.3969 9.9467 15.8452 11.843 14.6752 13.35L18.1627 16.8375C18.2548 16.9233 18.3287 17.0268 18.38 17.1418C18.4312 17.2568 18.4588 17.381 18.461 17.5068C18.4632 17.6327 18.44 17.7578 18.3929 17.8745C18.3457 17.9912 18.2756 18.0973 18.1865 18.1863C18.0975 18.2753 17.9915 18.3455 17.8747 18.3926C17.758 18.4398 17.633 18.463 17.5071 18.4607C17.3812 18.4585 17.2571 18.431 17.1421 18.3797C17.0271 18.3285 16.9236 18.2546 16.8377 18.1625L13.3502 14.675Z"
        fill="var(--accent-color)"
      />
    </svg>
  ),
  searchButton: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1222_37465)">
        <path
          d="M7 13.5C10.5899 13.5 13.5 10.5899 13.5 7C13.5 3.41015 10.5899 0.5 7 0.5C3.41015 0.5 0.5 3.41015 0.5 7C0.5 10.5899 3.41015 13.5 7 13.5Z"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.5 9C7.88071 9 9 7.88071 9 6.5C9 5.11929 7.88071 4 6.5 4C5.11929 4 4 5.11929 4 6.5C4 7.88071 5.11929 9 6.5 9Z"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 10L8.27002 8.27002"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1222_37465">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  searchCompass: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM14.8612 8.04584L8.59084 10.1359C7.80305 10.3985 7.80305 11.5128 8.59084 11.7754L10.9063 12.5472C11.1643 12.6333 11.3667 12.8357 11.4528 13.0937L12.2246 15.4092C12.4872 16.1969 13.6015 16.1969 13.8641 15.4092L15.9542 9.13883C16.1793 8.46332 15.5367 7.82067 14.8612 8.04584Z"
        fill="#28303F"
      />
    </svg>
  ),
  arrow: (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="var(--explore-color)"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M15.7071 8.70711C16.0976 8.31658 16.0976 7.68342 15.7071 7.29289L9.34315 0.928932C8.95262 0.538408 8.31946 0.538408 7.92893 0.928932C7.53841 1.31946 7.53841 1.95262 7.92893 2.34315L13.5858 8L7.92893 13.6569C7.53841 14.0474 7.53841 14.6805 7.92893 15.0711C8.31946 15.4616 8.95262 15.4616 9.34315 15.0711L15.7071 8.70711ZM0 9H15V7H0V9Z" />
    </svg>
  ),
  home: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.3607 18.0108C20.3607 20.214 18.4891 22 16.1804 22H7.81965C5.5109 22 3.6393 20.214 3.6393 18.0108V13.133C3.6393 12.4248 3.34447 11.7456 2.81969 11.2448C1.60381 10.0845 1.76187 8.16205 3.15251 7.19692L9.54124 2.763C11.0071 1.74567 12.9929 1.74567 14.4588 2.763L20.8475 7.19691C22.2381 8.16205 22.3962 10.0845 21.1803 11.2448C20.6555 11.7456 20.3607 12.4248 20.3607 13.133V18.0108ZM12 18C13.1046 18 14 17.1046 14 16C14 14.8954 13.1046 14 12 14C10.8954 14 10 14.8954 10 16C10 17.1046 10.8954 18 12 18Z"
        fill="var(--explore-color)"
      />
    </svg>
  ),
  homeWhite: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.3607 18.0108C20.3607 20.214 18.4891 22 16.1804 22H7.81965C5.5109 22 3.6393 20.214 3.6393 18.0108V13.133C3.6393 12.4248 3.34447 11.7456 2.81969 11.2448C1.60381 10.0845 1.76187 8.16205 3.15251 7.19692L9.54124 2.763C11.0071 1.74567 12.9929 1.74567 14.4588 2.763L20.8475 7.19691C22.2381 8.16205 22.3962 10.0845 21.1803 11.2448C20.6555 11.7456 20.3607 12.4248 20.3607 13.133V18.0108ZM12 18C13.1046 18 14 17.1046 14 16C14 14.8954 13.1046 14 12 14C10.8954 14 10 14.8954 10 16C10 17.1046 10.8954 18 12 18Z"
        fill="white"
      />
    </svg>
  ),
  wikipediaCharacter: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M1 9C1 5.22905 1 3.34274 2.17137 2.17137C3.34274 1 5.22821 1 9 1C12.7709 1 14.6573 1 15.8286 2.17137C17 3.34274 17 5.22821 17 9C17 12.7709 17 14.6573 15.8286 15.8286C14.6573 17 12.7718 17 9 17C5.22905 17 3.34274 17 2.17137 15.8286C1 14.6573 1 12.7718 1 9Z"
        stroke="#FF549C"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.10547 5.63153H3.98968M3.98968 5.63153H4.78968M3.98968 5.63153L6.15978 11.3747C6.62294 12.6 6.85368 13.2105 7.23178 13.2105C7.61073 13.2105 7.84147 12.5991 8.30378 11.3747L10.4739 5.63153H11.1055M6.89494 5.63153H7.52652L9.69663 11.3747C10.1598 12.5991 10.3905 13.2105 10.7686 13.2105C11.1476 13.2105 11.3783 12.5991 11.8406 11.3747L14.0107 5.63153M14.0107 5.63153H13.2107M14.0107 5.63153H14.8949"
        stroke="#FF549C"
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  wiki: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      width="26"
      height="26"
      viewBox="0 0 48 48"
    >
      <path
        fill="#767676"
        d="M9.691,14.851c0,0,3.766,0.83,5.777-0.128c0.798-0.383-0.223-0.67-0.191-1.085	s0.255-0.638,1.021-0.957c0.766-0.319,1.691-0.383,1.628,0.255c-0.064,0.638-0.064,0.989,0.734,0.862s4.628-1.628,5.266-2.234	c0.638-0.606,2.33,3.862,2.33,3.862l-3.734,5.394l-8.649,2.138l-6.702-3.16L9.691,14.851z"
      ></path>
      <path
        fill="#767676"
        d="M31.638,17.404c0-3.607-1.495-6.861-3.893-9.19c-0.601,0.115-1.104,0.162-1.306,0.174	c-0.407,0.024-0.862-0.407-0.814-0.694s-0.455-0.622-1.34-0.407c-0.886,0.215-0.942,0.576-0.942,0.576l-0.04,0.075	c-0.053,0.099-0.032,0.096-0.032,0.096s0.546,0.367,0.535,0.665c-0.054,0.072-0.132,0.15-0.262,0.24	c-0.648,0.443-1.721,0.607-2.285,0.665c-0.209,0.021-0.36,0.177-0.403,0.375c-0.051,0.075-0.087,0.162-0.09,0.26	c-0.013,0.403,0.048,1.031,0.437,1.637c0.15,0.234,0.477,0.295,0.698,0.126c0.741-0.569,1.412-0.914,1.906-0.091	c0.183,0.305,0.242,0.607,0.183,0.857c-0.196,0.352-0.709,0.534-1.602,0.308c-0.272-0.069-0.545,0.103-0.604,0.368	c-0.047,0.066-0.083,0.141-0.091,0.228c-0.084,0.95,0.081,2.359,0.416,3.284c-1.208,0.236-3.985,0.631-5.188,1.265	c-0.099,0.052-0.153,0.15-0.163,0.253c-0.1,0.123-0.105,0.311,0.017,0.427c0.26,0.249,0.483,0.608,0.419,0.947	c-0.149,0.285-0.536,0.54-1.359,0.676c-1.287,0.212-1.485-0.246-1.307-0.752c0.076-0.151,0.172-0.3,0.283-0.431	c0.043-0.051,0.064-0.11,0.07-0.169c0.001-0.001,0.001-0.001,0.002-0.002c0.164-0.194,0.041-0.494-0.21-0.528	c-1.273-0.174-3.487-0.145-4.655,0.112c0,0-0.087-1.288,0.393-2.56c0.166-0.394,0.328-0.656,0.63-0.997	c0.234-0.234,0.581,0.133,0.793,0.416c0.132,0.175,0.427,0.082,0.608-0.04c0.234-0.158,0.516-0.429,0.666-0.841	c0.184-0.367,0.265-0.868,0.049-1.55c-0.066-0.207-0.729-0.525-0.939-0.47c-0.529,0.138-0.811,0.302-0.646-0.28	c0.029-0.06,0.051-0.116,0.097-0.185c0.498-0.755,0.957-1.424,1.224-2.101c0.111-0.251,0.204-0.503,0.255-0.759	c0.039-0.195-0.506-0.577-0.822-0.532c-0.153,0.045-0.135-0.054-0.12-0.123c0.033-0.059,0.076-0.124,0.132-0.196	c0.47-0.596,0.913-0.62,1.122-0.451c0.111,0.089,0.27,0.085,0.379-0.006c0.431-0.36,0.651-0.709,0.751-0.995	c0.234-0.475,0.142-0.823-0.015-0.815l-0.638-0.223c0,0-2.076,1.529-3.225,2.127C10.48,8.274,10.139,8.322,9.82,8.346	C9.422,8.742,9.043,9.157,8.678,9.584c-0.711,0.921-1.299,1.942-1.743,3.036c-0.763,1.804-1.129,3.816-0.97,5.934	c0.48,6.413,5.86,11.589,12.286,11.832c5.519,0.208,10.294-3.077,12.301-7.818C31.249,20.987,31.638,19.242,31.638,17.404z"
      ></path>
      <path
        fill="#bebebe"
        d="M44.895,20.915h-0.01c-0.031-0.306-0.079-0.606-0.122-0.908c-0.034-0.237-0.066-0.474-0.108-0.707	c-0.066-0.366-0.14-0.729-0.224-1.089c-0.038-0.162-0.082-0.32-0.124-0.481c-0.206-0.792-0.45-1.569-0.744-2.322	c-0.006-0.016-0.012-0.033-0.018-0.05c-0.163-0.416-0.341-0.824-0.529-1.227c-0.022-0.047-0.045-0.093-0.067-0.14	c-0.589-1.234-1.293-2.403-2.101-3.491l-0.733,0.273c-0.39-0.526-0.906-1.126-1.46-1.724c0.099-0.39-0.14-0.931-0.648-1.334	c-0.365-0.289-0.764-0.418-1.099-0.41c-0.822-0.756-1.564-1.348-1.963-1.509c-0.219,0.027-0.698,0.123-1.298,0.259	c1.258,0.754,0.609,1.473,0.412,1.52c-0.232,0.055-1.053,0.112-1.695-1.211c-1.295,0.328-2.698,0.732-3.331,1.036	c-0.827,0.397-1.851,0.597-2.545,0.692C27.441,9.672,28,11.519,28,13.5C28,19.299,23.299,24,17.5,24S7,19.299,7,13.5	c0-1.3,0.247-2.54,0.68-3.69c-0.087,0.113-0.175,0.225-0.263,0.338c-0.228,0.293-0.455,0.587-0.667,0.892	c-0.163,0.235-0.314,0.478-0.468,0.72c-0.188,0.295-0.372,0.592-0.545,0.897c-0.147,0.258-0.285,0.522-0.421,0.787	C5.16,13.748,5.011,14.057,4.87,14.37c-0.125,0.276-0.246,0.555-0.359,0.837c-0.127,0.318-0.242,0.642-0.354,0.968	c-0.099,0.288-0.2,0.576-0.287,0.87c-0.1,0.34-0.182,0.687-0.266,1.034c-0.07,0.29-0.148,0.578-0.205,0.872	c-0.079,0.403-0.132,0.815-0.187,1.226c-0.033,0.246-0.081,0.488-0.106,0.737l0,0C3.038,21.601,3,22.296,3,23	c0,11.598,9.402,21,21,21s21-9.402,21-21C45,22.296,44.962,21.601,44.895,20.915z"
      ></path>
      <path
        fill="#e1e1e1"
        d="M33.811,6.018c-0.056,0.012-0.106,0.023-0.164,0.036c1.258,0.754,0.609,1.473,0.412,1.52	c-0.232,0.055-1.053,0.112-1.695-1.211c-1.295,0.328-2.698,0.732-3.331,1.036c-0.827,0.397-1.851,0.597-2.545,0.692	C27.441,9.672,28,11.519,28,13.5C28,19.299,23.299,24,17.5,24S7,19.299,7,13.5c0-1.294,0.245-2.529,0.674-3.674	c-3.017,3.808-4.637,8.773-4.04,14.13c0.984,8.827,8.123,15.959,16.953,16.924C32.186,42.149,42,33.098,42,21.755	C42,15.245,38.758,9.501,33.811,6.018z"
      ></path>
      <path
        fill="#efefef"
        d="M30.713,6.812c-0.166,0.049-0.327,0.098-0.482,0.146c-0.015,0.005-0.03,0.009-0.045,0.014	c-0.135,0.043-0.263,0.085-0.386,0.127c-0.026,0.009-0.053,0.018-0.079,0.027c-0.11,0.038-0.211,0.076-0.307,0.112	c-0.026,0.01-0.055,0.02-0.079,0.03c-0.114,0.045-0.217,0.089-0.304,0.13c-0.827,0.397-1.851,0.597-2.545,0.692	C27.441,9.672,28,11.519,28,13.5C28,19.299,23.299,24,17.5,24S7,19.299,7,13.5c0-1.289,0.243-2.518,0.668-3.658	C7.604,9.92,7.544,9.993,7.492,10.056c-2.327,3.183-3.549,7.223-3.036,11.575c0.88,7.465,6.938,13.472,14.411,14.273	C28.694,36.956,37,29.283,37,19.67C37,14.443,34.534,9.801,30.713,6.812z"
      ></path>
      <path
        fill="#f5f5f5"
        d="M27.107,7.991c-0.601,0.115-1.104,0.162-1.306,0.174c-0.407,0.024-0.862-0.407-0.814-0.694	s-0.455-0.622-1.34-0.407c-0.886,0.215-1.029,0.838-1.029,0.838s1.197,0.192,0.287,0.814c-0.648,0.443-1.721,0.607-2.285,0.665	c-0.24,0.025-0.413,0.223-0.421,0.464c-0.013,0.403,0.048,1.031,0.437,1.637c0.15,0.234,0.477,0.295,0.698,0.126	c0.741-0.569,1.412-0.914,1.906-0.091c0.522,0.869,0.096,1.738-1.491,1.336c-0.292-0.074-0.596,0.125-0.622,0.425	c-0.088,0.998,0.092,2.517,0.462,3.433c-1.143,0.233-4.067,0.634-5.306,1.287c-0.187,0.098-0.226,0.363-0.073,0.509	c0.531,0.508,0.923,1.475-1.012,1.794c-1.813,0.299-1.481-0.73-0.952-1.355c0.164-0.194,0.041-0.494-0.21-0.528	c-1.273-0.174-3.487-0.145-4.655,0.112c0,0-0.168-2.37,1.149-3.854c0.234-0.234,0.58,0.133,0.793,0.416	c0.132,0.175,0.373,0.208,0.554,0.086c0.432-0.291,1.045-0.95,0.643-2.219c-0.066-0.207-0.294-0.301-0.504-0.246	c-0.622,0.163-1.519,0.059-0.912-0.861c0.641-0.972,1.229-1.801,1.408-2.688c0.039-0.195-0.148-0.355-0.346-0.33	c-0.465,0.058-0.874-0.079-0.392-0.692c0.47-0.597,0.913-0.62,1.122-0.451c0.111,0.089,0.27,0.085,0.379-0.007	c1.004-0.84,0.903-1.65,0.662-1.638l-1.589,0.181c0,0-1.125,1.125-2.274,1.723c-0.232,0.1-0.573,0.149-0.892,0.173	C8.784,8.519,8.405,8.933,8.039,9.36c-1.856,2.403-2.89,5.473-2.641,8.798c0.48,6.413,5.86,11.589,12.287,11.832	C24.991,30.266,31,24.425,31,17.181C31,13.574,29.505,10.32,27.107,7.991z"
      ></path>
      <path
        fill="#404040"
        d="M32.814,34.471c0,0-0.335,0.646-0.144,0.934c0.622,0,1.436,0,1.436,0s0.311,1.293-0.191,2.705	c0.311-0.239,0.551-0.574,0.551-0.574s0.359-1.915,0.263-2.992C34.178,34.566,32.814,34.471,32.814,34.471z"
      ></path>
      <path
        fill="#767676"
        d="M42.652,30.306c-0.455,0.383-1.077,1.34-1.077,1.34l1.34-0.886 C42.915,30.761,43.106,29.923,42.652,30.306z"
      ></path>
      <path
        fill="#767676"
        d="M41.359,32.699c0,0,0.407-0.287,0.694-0.431c-0.168,0.933-0.886,1.316-0.886,1.316 s0,0.144,0.024,0.742c1.317-0.957,1.46-2.992,1.46-2.992l-1.364,0.91L41.359,32.699z"
      ></path>
      <path
        fill="#404040"
        d="M35.579,28.748l-0.578,0.12c-0.117-0.603-0.519-2.628-0.781-3.488l0.581-0.401l-0.048-0.215	l-2.035,0.79l0.036,0.156l0.771-0.093c0.027,0.102,0.06,0.226,0.097,0.372c-0.238,0.567-0.985,2.331-1.403,3.152	c-0.176-0.866-0.441-2.115-0.633-2.743l0.581-0.401l-0.048-0.215l-2.035,0.79l0.036,0.156l0.771-0.093	c0.171,0.647,0.596,2.294,0.793,3.469L31.119,30.4l0.064,0.202l1.852-0.677l-0.075-0.154l-0.595,0.103	c-0.018-0.093-0.042-0.215-0.072-0.364c0.519-0.962,1.147-2.396,1.422-3.156c0.202,0.799,0.466,1.911,0.608,2.765l-0.564,0.319	l0.071,0.2l1.828-0.738L35.579,28.748z"
      ></path>
      <path
        fill="#404040"
        d="M18.5,31.638l-0.638-0.447c0,0,0.048,0.941-0.782,1.867C17.638,32.755,18.5,31.638,18.5,31.638z"
      ></path>
      <path
        fill="#404040"
        d="M20.72,34.769l-1.124-0.012l-0.18-0.662l0.537-0.067c0.068-0.009,0.117-0.071,0.108-0.14 s-0.063-0.127-0.14-0.108l-0.572,0.073l-0.158-0.578l0.613-0.06c0.069-0.006,0.119-0.067,0.112-0.136 c-0.006-0.069-0.069-0.128-0.136-0.112l-0.656,0.064l-0.114-0.419l0.067-0.172l0.693-0.054c0.068-0.006,0.12-0.065,0.115-0.135 c-0.007-0.068-0.074-0.122-0.135-0.115l-0.572,0.045l0.23-0.59l-0.223-0.239l-0.339,0.88l-1.017,0.425 c-0.057,0.023-0.088,0.084-0.074,0.144l0.341,1.467c-0.001,0.013-0.008,0.025-0.005,0.039c0.002,0.007,0.013,0.006,0.016,0.012 l0.189,0.811c0.014,0.058,0.065,0.097,0.122,0.097c0.008,0,0.017-0.001,0.025-0.003l1.058-0.22l1.213,0.016 c0.001,0,0.001,0,0.002,0c0.068,0,0.124-0.055,0.125-0.123C20.844,34.826,20.788,34.77,20.72,34.769z M18.023,32.846l0.699-0.292 l-0.047,0.122l0.124,0.448l-0.633,0.339L18.023,32.846z M18.318,34.112l-0.092-0.396l0.642-0.345l0.15,0.542L18.318,34.112z M18.374,34.355l0.71-0.202l0.179,0.647l-0.75,0.154L18.374,34.355z"
      ></path>
      <path
        fill="#404040"
        d="M16.694,34.131l-0.232-0.418l0.411-0.226l0.516,0.272c0.063,0.033,0.137,0.009,0.169-0.052 c0.032-0.062,0.009-0.137-0.052-0.169l-0.575-0.304c-0.037-0.02-0.08-0.021-0.119,0.001l-0.497,0.273 c-0.035-0.016-0.074-0.021-0.109-0.001c-0.036,0.02-0.052,0.055-0.057,0.093l-0.288,0.158l-0.088-0.013l1.201-1.651 c0.041-0.056,0.028-0.134-0.027-0.174c-0.054-0.041-0.133-0.029-0.174,0.027l-0.69,0.947l-0.588-0.259l0.78-1.186 c0.038-0.058,0.021-0.135-0.036-0.173c-0.056-0.038-0.135-0.022-0.173,0.036l-0.861,1.309c-0.021,0.03-0.025,0.068-0.016,0.104 c0.011,0.035,0.036,0.064,0.069,0.079l0.674,0.297l-0.484,0.665c-0.026,0.035-0.031,0.081-0.015,0.122 c0.018,0.04,0.054,0.068,0.098,0.075l0.335,0.048c0.006,0.001,0.012,0.001,0.018,0.001c0.021,0,0.042-0.005,0.061-0.016l0.3-0.165 l0.223,0.4l0.172,1.001c0.011,0.061,0.063,0.104,0.123,0.104c0.007,0,0.014-0.001,0.021-0.002c0.067-0.012,0.113-0.076,0.102-0.145 l-0.176-1.021C16.706,34.156,16.701,34.143,16.694,34.131z"
      ></path>
      <path
        fill="#404040"
        d="M17.121,34.201c-0.058-0.04-0.135-0.029-0.175,0.028c-0.04,0.056-0.027,0.134,0.028,0.175 l0.75,0.543c0.022,0.016,0.048,0.023,0.073,0.023c0.039,0,0.077-0.018,0.102-0.052c0.04-0.056,0.027-0.134-0.028-0.175 L17.121,34.201z"
      ></path>
      <path
        fill="#404040"
        d="M16.006,34.402c-0.003-0.001-0.007-0.001-0.011-0.001c-0.064,0-0.119,0.049-0.124,0.114 l-0.064,0.719c-0.007,0.068,0.044,0.129,0.113,0.135c0.003,0.001,0.007,0.001,0.011,0.001c0.064,0,0.119-0.049,0.124-0.114 l0.064-0.719C16.126,34.469,16.075,34.408,16.006,34.402z"
      ></path>
      <path
        fill="#404040"
        d="M22.869,41.015c0,0,0.001,0.013,0.002,0.021c-0.069-0.162-0.224-0.358-0.529-0.592	c-0.89-0.686-2.033-1.064-3.306-1.095l-0.038-0.001c-0.013,0-0.026-0.001-0.039-0.001c-0.342,0-0.625,0.153-0.668,0.365	c-0.021,0.106,0,0.306,0.387,0.452c0.367,0.14,0.637,0.149,0.807,0.032c0.156-0.107,0.161-0.274,0.161-0.293	c0-0.068-0.043-0.129-0.125-0.123c-0.066,0-0.122,0.054-0.125,0.12c0,0.006-0.004,0.059-0.056,0.092	c-0.044,0.029-0.192,0.084-0.573-0.063c-0.179-0.067-0.236-0.139-0.23-0.168c0.012-0.061,0.186-0.16,0.453-0.164l0.04,0.001	c1.202,0.028,2.324,0.398,3.16,1.042c0.372,0.286,0.542,0.539,0.455,0.676c-0.151,0.241-1.028,0.282-1.822-0.12	c-0.042-0.021-0.091-0.017-0.13,0.01c-0.038,0.027-0.057,0.073-0.05,0.12c0.015,0.1-0.042,0.2-0.155,0.273	c-0.242,0.158-0.761,0.194-1.428-0.223c-0.086-0.053-0.129-0.122-0.122-0.194c0.008-0.073,0.065-0.138,0.15-0.169	c0.186-0.063,0.439,0.035,0.681,0.271c0.049,0.05,0.128,0.048,0.177-0.001c0.048-0.05,0.047-0.129-0.002-0.177	c-0.451-0.442-0.808-0.378-0.94-0.328c-0.176,0.063-0.296,0.208-0.313,0.378c-0.015,0.147,0.063,0.282,0.19,0.383	c-0.004-0.001-0.008-0.002-0.012-0.003c0.007,0.005,0.013,0.007,0.02,0.012c0.016,0.012,0.022,0.03,0.04,0.04	c0.124,0.078,0.243,0.138,0.358,0.19c1.174,0.607,1.965,0.203,1.592-0.281c0.122,0.052,0.247,0.094,0.371,0.13	C22.626,42.182,23.356,41.686,22.869,41.015z"
      ></path>
      <path
        fill="#404040"
        d="M17.607,24.522l-0.282,0.603l-1.038,0.205l-0.023-0.313c0.606-0.367,1.02-0.98,0.99-1.664	c-0.045-1.044-1.006-1.754-2.169-1.704s-2.088,1.03-2.043,2.074c0.036,0.842,0.652,1.42,1.497,1.588l0.077,0.295l-1.048,0.143	l-0.463-0.479l-0.112,0.128l0.399,0.941L15,26.111l-0.167-0.935c-0.678-0.098-1.191-0.648-1.226-1.465	c-0.04-0.929,0.602-1.794,1.419-1.829c0.817-0.035,1.498,0.604,1.538,1.533c0.026,0.59-0.234,1.131-0.636,1.457l0.018,0.119h-0.001	l0.145,0.939l1.594-0.304l0.072-1.02L17.607,24.522z"
      ></path>
      <path
        fill="#404040"
        d="M7.943,32.859c-0.174-0.253-0.333-0.581-0.471-0.923c0.002-0.012,0.012-0.019,0.013-0.032	c0.005-0.053-0.029-0.093-0.075-0.115c-0.056-0.149-0.099-0.295-0.143-0.444c0.029-0.001,0.058-0.008,0.082-0.028	c0.051-0.046,0.055-0.125,0.009-0.177c-0.047-0.052-0.113-0.11-0.19-0.166c-0.032-0.149-0.055-0.292-0.068-0.425	c0.092,0.017,0.183,0.038,0.278,0.049c0.005,0.001,0.01,0.001,0.015,0.001c0.063,0,0.116-0.047,0.124-0.11	c0.009-0.068-0.04-0.131-0.109-0.139c-0.12-0.014-0.236-0.039-0.353-0.063c-0.15-0.731-0.87-1.334-1.424-1.734	c-0.304-0.219-0.476-0.162-0.566-0.077c-0.189,0.175-0.134,0.622,0.001,0.987c-0.044-0.028-0.074-0.048-0.076-0.049	c-0.057-0.041-0.135-0.026-0.174,0.031c-0.039,0.057-0.025,0.135,0.031,0.174c0.016,0.011,0.169,0.114,0.408,0.247	c0.292,0.594,0.75,2.561,0.754,2.583c0.017,0.066,0.078,0.108,0.15,0.094c0.067-0.016,0.109-0.083,0.094-0.15	c-0.018-0.075-0.36-1.548-0.654-2.346c0.338,0.164,0.765,0.337,1.239,0.452c0.007,0.097,0.033,0.211,0.051,0.318	c-0.18-0.079-0.37-0.116-0.511-0.039C6.262,30.842,6.144,31,6.25,31.386c0.015,0.056,0.065,0.092,0.12,0.092	c0.011,0,0.021-0.001,0.033-0.005c0.066-0.018,0.105-0.087,0.087-0.153c-0.046-0.171-0.043-0.294,0.008-0.322	c0.081-0.039,0.271,0.027,0.444,0.133c0.063,0.263,0.153,0.533,0.256,0.8c-0.004,0.001-0.003,0.009-0.008,0.01	c-0.143,0.021-0.446-0.131-0.549-0.326c-0.031-0.062-0.107-0.084-0.168-0.053c-0.062,0.031-0.085,0.107-0.053,0.168	c0.133,0.255,0.476,0.464,0.736,0.464c0.028,0,0.056-0.003,0.082-0.008c0.022-0.004,0.034-0.022,0.054-0.03	c0.134,0.314,0.282,0.613,0.444,0.848c0.024,0.035,0.063,0.054,0.103,0.054c0.024,0,0.05-0.007,0.071-0.022	C7.969,32.994,7.982,32.916,7.943,32.859z M5.426,29.642c-0.21-0.343-0.295-0.887-0.19-0.983c0.018-0.013,0.09-0.019,0.25,0.098	c0.731,0.527,1.143,1.007,1.285,1.462c-0.531-0.145-1.002-0.361-1.325-0.535C5.439,29.672,5.432,29.652,5.426,29.642z"
      ></path>
      <path
        fill="#404040"
        d="M6.555,21.737v-0.299l-0.41-0.131c-0.018-0.175-0.116-0.903-0.549-1.052	c-0.422-0.145-0.632,0.106-0.611-0.625c-0.058,0-0.16-0.015-0.16-0.015c-0.077,0.363-0.095,0.757,0.187,0.961	c0.247,0.179,0.783-0.103,0.883,0.651l-1.181-0.376L4.569,20.66l-0.016,0.479l0.601,0.18c-0.077,0.436-0.183,1.278,0.06,1.652	c0.144,0.112,0.179,0.159,0.371-0.108c0.215-0.299,0.245-0.191,0.261-0.032c0.016,0.16-0.016,0.878-0.463,0.782	s-0.638-0.415-0.734-2.186c-0.048,1.612-0.016,2.505,0.702,2.697c0.718,0.192,0.83-0.846,0.638-1.771	c-0.192-0.926-0.456,0.164-0.584,0.211c-0.107,0.04-0.106-0.69-0.075-1.192L6.555,21.737z"
      ></path>
      <path
        fill="#404040"
        d="M7.186,15.228c-0.072-0.153,0.342-0.514,0.342-0.514l0.009-0.82l-0.559,0.559 c0,0-0.442,0.009-0.676,0.036c0.37-0.387,0.342-0.91-0.081-0.505c-0.424,0.406-0.55,0.946-0.55,0.946l1.162-0.099l0.568-0.604 v0.261c0,0-0.18,0.207-0.351,0.397c-0.189,0.73,0.37,0.694,0.37,0.694l0.487-0.46l0.045-0.306L7.52,15.291 C7.519,15.291,7.258,15.381,7.186,15.228z M5.96,14.507c0,0,0.171-0.351,0.315-0.378s0.162,0.117-0.099,0.36 C6.095,14.498,5.96,14.507,5.96,14.507z"
      ></path>
      <path
        fill="#404040"
        d="M8.42,12.948l-0.73,1.874c0,0,0.892-0.577,1.09-1.28C8.979,12.84,8.42,12.948,8.42,12.948z M8.555,13.588C8.429,13.957,8.051,14.3,8.051,14.3l0.414-1.009C8.465,13.291,8.682,13.219,8.555,13.588z"
      ></path>
      <path
        fill="#404040"
        d="M11.34,7.185c-0.053-0.045-0.132-0.039-0.176,0.014c-0.041,0.047-0.648,0.76-1.148,1.411	C9.939,8.626,9.795,8.656,9.643,8.691c0.11-0.15,0.245-0.296,0.308-0.359C10,8.283,10,8.204,9.952,8.155	c-0.049-0.049-0.128-0.049-0.177,0C9.758,8.171,9.384,8.547,9.269,8.838C9.251,8.882,9.26,8.933,9.292,8.968	C9.315,8.995,9.35,9.009,9.385,9.009c0.011,0,0.022-0.001,0.033-0.004c0.106-0.029,0.244-0.061,0.371-0.089	C9.588,9.19,9.427,9.433,9.375,9.57C9.358,9.616,9.369,9.667,9.403,9.702c0.034,0.034,0.087,0.045,0.132,0.03	C9.6,9.708,9.678,9.691,9.751,9.681l-0.195,0.34c-0.034,0.06-0.014,0.136,0.046,0.17c0.02,0.011,0.041,0.017,0.063,0.017	c0.043,0,0.085-0.022,0.108-0.063l0.315-0.55c0.022-0.039,0.022-0.087-0.001-0.126c-0.023-0.039-0.068-0.07-0.111-0.061	c-0.008,0-0.113,0.004-0.242,0.022c0.107-0.169,0.271-0.392,0.453-0.63c0.007-0.008,0.012-0.013,0.017-0.022	c0.402-0.524,0.897-1.12,1.151-1.417C11.398,7.309,11.393,7.23,11.34,7.185z"
      ></path>
      <path
        fill="#404040"
        d="M30.723,16.252l-1.087,0.294l0.066,0.132l0.163-0.008c0.176,0.036,0.292,0.099,0.287,0.219	l-0.219,2.669l-1.087-1.187l0.273-1.242c0.031-0.156,0.128-0.255,0.269-0.316l0.175-0.075l-0.072-0.156l-1.153,0.294l0.078,0.144	l0.239-0.015c0.149,0.082,0.232,0.184,0.194,0.321l-0.17,0.862l-0.701-0.765c-0.081-0.095-0.061-0.177,0.016-0.251l0.235-0.115	l-0.084-0.144l-1.305,0.323l0.108,0.144l0.304-0.016c0.052,0.021,0.104,0.051,0.155,0.101l1.157,1.307l-0.245,1.242l-1.88-2.242	c-0.022-0.033-0.017-0.071-0.002-0.112l0.355-0.197L26.68,17.31l-1.503,0.406l0.072,0.108l0.283,0.004	c0.156,0.021,0.291,0.071,0.389,0.176l2.316,2.761l0.09-0.03l0.393-1.786l1.199,1.354l0.096-0.054l0.402-3.418	c0.013-0.175,0.124-0.293,0.283-0.384l0.083-0.042L30.723,16.252z"
      ></path>
      <path
        fill="#404040"
        d="M40.64,13.838c-0.455-0.539-0.73,0.012-0.634,0.718s1.065,1.58,1.065,1.58	c-0.215,1.496-1.879,0.132-2.442-0.862c0.491,1.604,2.082,2.729,2.561,1.843C41.669,16.231,41.094,14.376,40.64,13.838z M40.4,14.747c-0.203-0.443,0.12-0.467,0.299-0.156s0.239,0.407,0.335,0.814C41.035,15.406,40.604,15.19,40.4,14.747z"
      ></path>
      <path
        fill="#404040"
        d="M37.6,8.895c-0.275-0.18-0.73-0.778-0.73-0.778l-0.44,0.377c-0.324-0.3-0.672-0.574-0.864-0.677	c-0.215-0.096-0.778,0.12-0.73,0.12c0,0-0.694,0.227-0.371,1.089c0.323,0.862,1.017,1.484,1.017,1.484s0.706,0.694,1.221-0.335	c0.467-0.251,0.658-0.491,0.395-0.934C37,9.076,36.811,8.862,36.595,8.649c0.048-0.054,0.113-0.127,0.18-0.21	C37.085,8.955,37.384,9.063,37.6,8.895z M35.972,10.283c-0.347-0.299-1.041-1.424-1.245-1.699c-0.203-0.275,0.024-0.443,0.024-0.443	s1.484,1.723,1.735,2.13C36.427,10.367,36.319,10.582,35.972,10.283z M36.81,9.457c0.168,0.287,0.156,0.395-0.072,0.503	c-0.239-0.515-1.699-1.987-1.699-1.987s0.144-0.156,0.407,0.048C35.709,8.225,36.642,9.17,36.81,9.457z"
      ></path>
      <path
        fill="#404040"
        d="M25.911,9.389c-0.054,0.153-0.369,0.234-0.369,0.234l-0.394,0.112l-0.165-0.274l0.081-0.171 l-0.523-0.045l-0.189,0.189l0.279,0.045l0.137,0.364l-0.746,0.212c-0.209-0.124-0.499,0.001-0.499,0.001s-0.018,0.108,0.054,0.099 s0.216,0.126,0.216,0.126s0.144,0.261,0.297,0.595c0.153,0.333,0.523,0.189,0.523,0.189s-0.251-0.539-0.438-0.857l1.727-0.522 c0.261,1.289-0.27,1.874-0.667,2.577c1.541-1.081,1.198-2.46,1.198-2.46s0.009-0.099,0.054-0.189 C26.407,9.524,26.19,9.461,25.911,9.389z"
      ></path>
      <path
        fill="#404040"
        d="M28.056,11.461l-0.351-0.703l0.054-0.216l-0.138,0.008c0.124-0.178,0.23-0.377,0.282-0.62 c-0.126-0.108-0.541-0.117-0.541-0.117l0.09,0.117c0,0-0.081,0.856-0.793,1.433c0.201-0.108,0.495-0.291,0.755-0.558l0.381,0.693 c0,0-0.036-0.009-0.054,0.144c0.144,0.153,0.351,0.135,0.351,0.135L28.056,11.461z"
      ></path>
      <g>
        <path
          fill="#404040"
          d="M42.592,23.709c0.01,0.001,0.021,0.001,0.03,0.001c0.269,0,0.501-0.338,0.546-0.805l0,0 c0.047-0.485-0.131-0.872-0.413-0.899c-0.009-0.001-0.02,0.007-0.03,0.008l-0.017-0.109l-0.18-0.09l0.048,0.239 c-0.08,0.039-0.157,0.1-0.22,0.198c-0.094,0.147-0.156,0.346-0.176,0.559C42.132,23.295,42.31,23.682,42.592,23.709z M42.566,22.386c0.052-0.082,0.112-0.131,0.158-0.131c0.002,0,0.005,0,0.007,0c0.1,0.01,0.223,0.259,0.188,0.626 c-0.035,0.36-0.197,0.579-0.298,0.579c-0.002,0-0.004,0-0.007,0c-0.1-0.01-0.223-0.258-0.188-0.626 C42.444,22.663,42.495,22.499,42.566,22.386z"
        ></path>
        <path
          fill="#404040"
          d="M43.672,24.429c0,0-0.036-2.289-0.216-3.109c-0.18-0.009-0.424-0.045-0.424-0.045v0.189l0.27,0.225 c0,0,0.099,0.825,0.168,1.772c-0.191,0.2-0.778,0.811-0.988,0.976c-0.252,0.198-0.667,0.144-0.667,0.144 c0.144,0.261,0.442,0.288,0.442,0.288s0.153-0.18,0.252-0.234c0.069-0.042,0.147-0.106,0.227-0.176 c0.007,0.233,0.043,1.359,0.043,1.545c0.081-0.234,0.18-0.55,0.162-0.865c-0.013-0.226-0.017-0.638-0.018-0.856 c0.23-0.228,0.449-0.482,0.561-0.617c0.05,0.754,0.076,1.552,0.016,2.058C43.609,25.249,43.672,24.429,43.672,24.429z"
        ></path>
      </g>
      <path
        fill="#404040"
        d="M10.085,37.953c0,0-0.443-0.263-0.586-0.527c-0.144-0.263,0.203-0.359,0.61,0.084	s0.73,0.766,0.395,0.766c0.108,0.084,0.191,0.191,0.191,0.191s0.515,0.096,0.778,0.371c0.263,0.275,0.79,0.778,0.79,0.778	s0.18,0.275-0.275,0.132c0.072,0.096,0.144,0.191,0.144,0.191s0.91,0.227,0.251-0.467c-0.658-0.694-1.185-0.934-1.532-1.065	c0,0,0.096-0.335-0.156-0.586c-0.251-0.251-0.574-0.586-1.173-0.826c-0.598-0.239-0.215,0.323-0.108,0.467	c0.108,0.144,0.658,0.563,0.658,0.563L10.085,37.953z"
      ></path>
      <path
        fill="#767676"
        d="M31.364,41.83c-0.11,0-0.228-0.03-0.275-0.13c-0.084-0.178,0.133-0.35,0.332-0.48	c0.597-0.391,1.106-0.464,1.3-0.332c0.051,0.033,0.079,0.087,0.077,0.146c0,0.005,0,0.01-0.001,0.015l0.221-0.082l0.447-0.55	c0.043-0.054,0.121-0.063,0.176-0.018c0.054,0.043,0.062,0.122,0.018,0.176l-0.469,0.576c-0.014,0.017-0.032,0.03-0.053,0.038	l-0.847,0.315c-0.063,0.021-0.129-0.006-0.157-0.064c-0.027-0.059-0.005-0.129,0.052-0.161c0.115-0.065,0.229-0.145,0.301-0.203	c-0.13-0.006-0.354,0.041-0.642,0.187c0.112,0.016,0.139,0.064,0.152,0.09c0.016,0.029,0.043,0.106-0.037,0.192	c-0.125,0.137-0.227,0.2-0.414,0.26C31.5,41.818,31.434,41.83,31.364,41.83z M31.361,41.58c0.021,0.002,0.074-0.003,0.108-0.014	c0.05-0.017,0.091-0.031,0.125-0.049c-0.033-0.008-0.063-0.029-0.08-0.06C31.437,41.512,31.39,41.552,31.361,41.58z"
      ></path>
      <path
        fill="#767676"
        d="M33.651,40.954c-0.025,0-0.051-0.008-0.073-0.023c-0.056-0.04-0.068-0.118-0.028-0.175	c0.085-0.118,0.276-0.397,0.402-0.618c-0.204,0.055-0.438,0.146-0.514,0.27c-0.024,0.041-0.028,0.08-0.011,0.128	c0.022,0.065-0.012,0.137-0.076,0.16c-0.066,0.024-0.137-0.012-0.16-0.076c-0.042-0.119-0.03-0.237,0.033-0.342	c0.204-0.334,0.903-0.434,0.934-0.438c0.035-0.007,0.086,0.011,0.113,0.045c0.027,0.033,0.036,0.079,0.021,0.12	c-0.096,0.275-0.521,0.872-0.54,0.897C33.729,40.936,33.69,40.954,33.651,40.954z"
      ></path>
      <g>
        <path
          fill="#bebebe"
          d="M3.875,26.167c0.139,0.09,0.395,0.255,0.606,0.104c0.233-0.167,0.163-0.498-0.005-1.172 c-0.052-0.208-0.031-0.317,0.003-0.348c0.063-0.058,0.291-0.041,0.496,0.035c0.132,0.051,0.5,0.308,0.614,0.579 c0.051,0.119,0.03,0.192,0.011,0.236c-0.26,0.595-0.117,1.41,0.333,1.898c0.46,0.499,1.972,0.875,3.159,0.777 c0.029-0.003,0.071-0.006,0.103-0.009c-0.024,0.457-0.059,0.894-0.103,1.266c-0.116,0.974,0.383,2.159,1.091,2.59 c0.351,0.214,0.713,0.216,1.021,0.009c0.421-0.286,0.764-0.386,1.008-0.305c0.252,0.084,0.462,0.369,0.626,0.849 c0.23,0.675,0.112,0.896,0.051,0.96c-0.094,0.097-0.307,0.107-0.572,0.028l-0.146-0.045c-0.521-0.164-1.307-0.409-1.754-0.028 c-0.244,0.206-0.335,0.548-0.271,1.017c0.054,0.392,0.248,0.839,0.507,1.297c-0.966-0.297-1.612-0.818-1.649-1.005 c-0.117-0.585-0.517-0.913-1.314-1.387c-0.347-0.207-0.609-0.22-0.777-0.041c-0.143,0.15-0.144,0.378-0.086,0.608 c-0.468-0.396-1.033-0.972-1.402-1.381l-0.028,0.025c0.283,0.54,0.593,1.063,0.92,1.574c0.382,0.338,0.767,0.629,1.036,0.701 c0.1,0.026,0.207-0.011,0.268-0.096c0.061-0.084,0.063-0.198,0.005-0.284c-0.211-0.315-0.312-0.601-0.333-0.747 c0.034,0.014,0.081,0.036,0.141,0.071c0.765,0.454,1.006,0.69,1.079,1.055c0.097,0.484,1.134,1.249,2.521,1.519 c0.591,0.867,1.348,1.714,1.903,2.263c-0.2,0.048-0.341,0.152-0.407,0.311c-0.098,0.229-0.057,0.61,0.691,1.117 c0.943,0.638,1.642,0.882,2.077,0.737c0.093-0.031,0.174-0.08,0.24-0.145c0.123,0.086,0.254,0.18,0.391,0.277 c0.69,0.492,1.54,1.099,2.258,1.402c0.193,0.475,1.196,0.886,2.356,1.212C21.67,43.879,22.82,44,24,44 c0.141,0,0.278-0.018,0.419-0.021c-3.9-0.583-5.683-1.371-5.766-1.654c0.013-0.113-0.053-0.221-0.159-0.261 c-0.684-0.259-1.565-0.889-2.274-1.395c-0.22-0.157-0.426-0.304-0.61-0.43c-0.065-0.044-0.146-0.057-0.221-0.029 c-0.074,0.024-0.133,0.083-0.157,0.157c-0.021,0.066-0.053,0.089-0.094,0.103c-0.196,0.071-0.738-0.069-1.635-0.678 c-0.42-0.284-0.511-0.475-0.519-0.499c0.021-0.021,0.178-0.085,0.551-0.006c0.111,0.02,0.225-0.032,0.275-0.135 c0.05-0.103,0.024-0.227-0.063-0.301c-0.458-0.391-1.328-1.297-2.035-2.249c0.205,0.013,0.413,0.02,0.627,0.007 c1.916-0.12,3.958,0.082,4.203,0.176c0.091,0.035,0.15,0.085,0.176,0.148c0.037,0.095,0.012,0.244-0.072,0.421 c-0.131,0.274-0.104,0.584,0.075,0.849c0.289,0.429,0.92,0.665,1.753,0.665c0.091,0,0.184-0.003,0.279-0.008 c0.761-0.046,2.063-0.213,2.231-0.818c0.038-0.137,0.046-0.405-0.333-0.667c-0.283-0.195-0.443-0.389-0.43-0.518 c0.014-0.127,0.211-0.279,0.526-0.409c0.737-0.302,2.497-0.82,4.258-1.076c0.516,0.929,1.364,1.495,1.902,1.845 c0.151,0.099,0.323,0.251,0.284,0.42c-0.061,0.258-0.55,0.582-1.182,0.654c-0.164,0.019-0.341,0.032-0.523,0.046 c-0.985,0.077-2.336,0.184-2.259,1.297c0.028,0.407,0.227,0.723,0.572,0.91c0.582,0.316,1.538,0.212,2.383-0.254 c1.143-0.632,1.491-0.473,1.842,0.123c0.393,0.667,0.118,1.221-0.081,1.42c-0.057,0.057-0.083,0.138-0.07,0.217 c0.014,0.079,0.063,0.147,0.136,0.184c0.054,0.028,0.557,0.255,1.517-0.11c0.324-0.122,0.449-0.105,0.465-0.114 c0.001,0.031-0.015,0.134-0.119,0.298c-0.206,0.329-1.041,0.607-1.643,0.315c-0.063-0.029-0.134-0.032-0.199-0.008 c-0.064,0.025-0.115,0.076-0.142,0.141c-0.14,0.35-0.512,0.748-0.756,0.985c0.264-0.04,0.531-0.071,0.792-0.121 c0.118-0.144,0.232-0.299,0.321-0.456c0.78,0.238,1.734-0.088,2.051-0.589c0.226-0.358,0.258-0.669,0.09-0.874 c-0.271-0.333-0.848-0.117-1.037-0.044c-0.349,0.132-0.614,0.169-0.799,0.171c0.198-0.396,0.301-0.998-0.093-1.668 c-0.626-1.063-1.458-0.892-2.516-0.307c-0.692,0.381-1.475,0.484-1.902,0.253c-0.193-0.105-0.296-0.271-0.313-0.507 c-0.039-0.574,0.722-0.679,1.8-0.763c0.188-0.015,0.371-0.029,0.541-0.049c0.698-0.079,1.476-0.461,1.611-1.035 c0.048-0.205,0.047-0.601-0.498-0.955c-0.602-0.391-1.231-0.848-1.645-1.492c0.353-0.04,0.702-0.071,1.038-0.082 c2.5-0.08,4.501-0.497,5.49-1.142c0.332-0.217,0.548-0.411,0.521-0.66c-0.026-0.255-0.278-0.353-0.502-0.438 c-0.15-0.059-0.339-0.131-0.399-0.227c-0.033-0.054-0.033-0.146,0.001-0.259c0.114-0.381,0.606-0.942,1.23-1.222 c0.753-0.337,1.953-0.518,2.279-0.245c0.032,0.026,0.105,0.088,0.057,0.293c-0.155,0.649-0.2,1.104,0.055,1.362 c0.236,0.239,0.618,0.189,0.962,0.113c0.506-0.116,2.103-1.028,3.694-2.278c0.071,0.36,0.076,0.767-0.036,1.251 c-0.266,1.145-0.611,1.553-0.854,1.694c-0.193,0.111-0.364,0.085-0.522,0.038c-0.19-0.059-0.444-0.008-0.714,0.139 c-0.473,0.259-0.848,0.735-1.002,1.276c-0.146,0.514-0.016,0.98,0.333,1.189c0.134,0.078,0.414,0.184,0.839,0.029 c-1.165,1.85-2.506,3.654-4.693,5.388c-0.334,0.265-0.638,0.501-0.919,0.716c0.746-0.326,1.463-0.702,2.161-1.109 c2.065-1.853,3.309-3.769,4.489-5.729c0.065-0.107,0.04-0.247-0.059-0.325c-0.1-0.078-0.238-0.071-0.33,0.018 c-0.618,0.604-1.048,0.694-1.231,0.583c-0.146-0.087-0.19-0.338-0.109-0.623c0.176-0.614,0.627-0.901,0.762-0.975 c0.192-0.105,0.306-0.104,0.331-0.099c0.219,0.065,0.552,0.127,0.916-0.084c0.484-0.282,0.841-0.94,1.09-2.014 c0.159-0.683,0.117-1.235-0.019-1.711c0.774-0.64,1.524-1.351,2.121-2.08c-0.003,0.459,0.098,0.736,0.304,0.828 c0.315,0.14,0.616-0.18,0.846-0.477c0.908-1.178,0.659-2.127,0.501-2.494c0.147-0.195,0.44-0.591,0.738-1.024 c0.03-0.327,0.035-0.661,0.05-0.992c-0.48,0.79-1.269,1.823-1.279,1.836c-0.063,0.083-0.067,0.197-0.013,0.286 c0.021,0.035,0.529,0.887-0.394,2.083c-0.106,0.138-0.184,0.217-0.234,0.261c-0.035-0.217-0.005-0.703,0.08-1.164 c0.021-0.116-0.067-0.193-0.178-0.238c-0.108-0.045-0.262,0.033-0.327,0.132c-0.587,0.884-1.469,1.764-2.397,2.544 c-0.145-0.318-0.322-0.604-0.493-0.875c-0.291-0.461-0.542-0.859-0.575-1.33c-0.032-0.472,0.079-0.819,0.333-1.035 c0.26-0.22,0.619-0.26,0.86-0.204c0.254,0.059,0.489-0.001,0.672-0.169c0.309-0.283,0.434-0.85,0.335-1.516 c-0.095-0.636-0.359-1.383-0.819-1.572c-0.206-0.085-0.431-0.049-0.631,0.1c-0.173,0.13-0.31,0.35-0.455,0.581 c-0.18,0.289-0.384,0.615-0.59,0.627c-0.004,0-0.009,0-0.013,0c-0.153,0-0.368-0.163-0.607-0.462 c-0.387-0.483-0.676-1.249-0.912-2.061c1.691-0.964,2.641-1.893,3.2-2.444c0.115-0.114,0.215-0.212,0.303-0.293 c0.116-0.106,0.333-0.276,0.491-0.213c0.154,0.062,0.328,0.366,0.367,0.908c0.046,0.646,0.232,1.05,0.555,1.202 c0.269,0.125,0.577,0.062,0.925-0.186c0.278-0.199,0.446-0.482,0.485-0.819c0.058-0.502-0.182-0.988-0.347-1.177 c-0.137-0.155-0.543-0.703-0.066-1.232c0.24-0.266,0.597-0.381,0.898-0.43c-0.048-0.16-0.091-0.322-0.142-0.481 c-0.373,0.069-0.81,0.225-1.127,0.577c-0.599,0.665-0.342,1.437,0.061,1.896c0.099,0.112,0.265,0.458,0.227,0.79 c-0.023,0.198-0.114,0.352-0.279,0.47c-0.181,0.129-0.335,0.179-0.421,0.141c-0.106-0.05-0.233-0.283-0.27-0.785 c-0.05-0.698-0.299-1.185-0.681-1.337c-0.215-0.085-0.566-0.1-1.014,0.309c-0.092,0.084-0.196,0.187-0.316,0.306 c-0.529,0.522-1.417,1.395-2.985,2.306c-0.101-0.383-0.192-0.765-0.277-1.123c-0.231-0.98-0.415-1.754-0.678-2.12 c-0.198-0.275-0.423-0.414-0.668-0.414h-0.001c-0.435,0-0.753,0.444-0.963,0.738c-0.04,0.055-0.075,0.105-0.107,0.145 c-0.099,0.123-0.434,0.334-0.778,0.286c-0.352-0.047-0.645-0.339-0.871-0.867c-0.241-0.563-0.274-1.004-0.096-1.274 c0.214-0.325,0.663-0.335,0.927-0.311c0.197,0.016,0.418,0.036,0.576-0.134c0.159-0.173,0.18-0.451,0.078-1.063 c-0.077-0.459-0.438-1.003-0.904-1.575c0.979-0.376,1.978-0.842,2.675-1.366c0.289-0.186,0.582-0.229,0.825-0.119 c0.215,0.096,0.366,0.298,0.405,0.54c0.063,0.392,0.351,0.657,0.788,0.728c0.533,0.088,1.28-0.143,1.531-0.624 c0.154-0.295,0.087-0.626-0.186-0.909c-0.349-0.361-0.344-0.495-0.347-0.495c0.032-0.04,0.194-0.074,0.256-0.087 c0.042-0.009,0.079-0.017,0.107-0.025l0.141-0.038c0.531-0.143,1.047-0.293,1.381-0.443c-0.051-0.07-0.096-0.146-0.148-0.215 l-0.733,0.273c-0.052-0.07-0.122-0.15-0.178-0.223c-0.186,0.054-0.353,0.099-0.453,0.126l-0.222,0.057 c-0.186,0.04-0.532,0.112-0.628,0.423c-0.082,0.267,0.065,0.583,0.463,0.995c0.178,0.185,0.123,0.29,0.103,0.329 c-0.126,0.239-0.633,0.421-1.009,0.362c-0.332-0.054-0.364-0.25-0.374-0.314c-0.066-0.409-0.326-0.751-0.695-0.916 c-0.4-0.18-0.861-0.124-1.314,0.165c-0.707,0.531-1.738,1.001-2.729,1.373c-0.226-0.259-0.465-0.521-0.702-0.781 c-0.53-0.58-1.03-1.127-1.242-1.503c-0.068-0.122-0.173-0.345-0.098-0.466c0.099-0.158,0.515-0.241,1.047-0.215 c0.409,0.026,0.601-0.144,0.697-0.287c0.175-0.261,0.149-0.65-0.075-1.123c-0.226-0.477-0.552-0.797-0.895-0.88 c-0.235-0.056-0.463-0.003-0.664,0.15c-0.407,0.314-0.666,0.407-1.127,0.142c-0.291-0.169-0.509-0.592-0.644-0.934 c-0.128,0.05-0.246,0.099-0.342,0.145c-0.04,0.019-0.083,0.034-0.123,0.052c0.155,0.39,0.432,0.922,0.86,1.17 c0.765,0.443,1.27,0.14,1.682-0.178c0.08-0.062,0.158-0.083,0.242-0.061c0.189,0.045,0.404,0.278,0.561,0.607 c0.163,0.345,0.161,0.555,0.11,0.631c-0.045,0.066-0.182,0.067-0.255,0.066c-0.782-0.042-1.287,0.11-1.498,0.45 c-0.161,0.259-0.132,0.587,0.087,0.975c0.239,0.426,0.759,0.994,1.309,1.596c0.183,0.2,0.376,0.411,0.565,0.626 c-1.03,0.358-1.946,0.596-2.31,0.666c-0.978,0.187-1.245,0.076-1.318-0.008c-0.06-0.069-0.021-0.221,0.007-0.306 c0.161-0.485,0.098-0.897-0.181-1.162c-0.292-0.277-0.933-0.492-2.318,0.052c-0.918,0.361-1.407,0.808-1.454,1.329 c-0.037,0.422,0.24,0.751,0.489,0.904c0.102,0.063,0.245,0.12,0.397,0.178c0.137,0.052,0.423,0.162,0.458,0.22 c0,0.001-0.021,0.116-0.386,0.363c-0.904,0.611-3.541,0.748-4.492,0.779c0.039,0.126,0.079,0.251,0.123,0.362 c-0.149,0.03-0.33,0.064-0.531,0.1c0.194,0.784,0.468,1.681,0.816,2.297c0.125,0.22,0.247,0.519,0.124,0.695 c-0.163,0.235-0.766,0.318-1.471,0.204c-0.56-0.093-1.099,0.07-1.475,0.445c-0.389,0.387-0.558,0.948-0.464,1.541 c0.121,0.758,0.534,1.619,1.186,1.834c0.294,0.097,0.758,0.1,1.295-0.426c0.344-0.336,0.739-0.444,1.146-0.307 c0.56,0.188,1.038,0.812,1.138,1.481c0.056,0.38,0.029,0.95-0.003,1.558c-2.179,0.104-5.007,0.982-5.63,1.294 c-0.448,0.224-0.69,0.498-0.721,0.815c-0.019,0.2,0.045,0.505,0.457,0.818c0.079,0.062,0.207,0.187,0.167,0.343 c-0.056,0.222-0.427,0.509-1.3,0.648c-1.143,0.184-1.543,0.034-1.68-0.121c-0.106-0.122-0.113-0.339-0.021-0.645 c0.125-0.413,0.1-0.769-0.077-1.055c-0.277-0.452-0.838-0.598-1.235-0.668c-0.438-0.075-1.908,0.021-3.591,0.16 c0.037-1.121,0.01-2.296-0.136-2.879c-0.16-0.64-0.476-0.885-0.713-0.979c-0.303-0.12-0.661-0.065-1.006,0.159 c-0.076,0.05-0.184,0.101-0.257,0.057c-0.139-0.077-0.27-0.433-0.251-1.052C7.376,22.309,7.634,22.059,7.713,22 c0.074-0.057,0.125-0.058,0.134-0.056l0.085,0.036c0.306,0.134,0.941,0.409,1.369,0.095c0.267-0.195,0.373-0.563,0.318-1.093 c-0.08-0.766,0.007-1.671,0.11-2.369c0.21-0.052,0.421-0.106,0.641-0.175c0.08-0.025,0.143-0.05,0.219-0.075 c-0.456,0.037-0.878,0.09-1.21,0.163c0,0-0.024-0.427,0.039-1.02c-0.03,0.139-0.079,0.377-0.131,0.69 c-0.639,0.13-1.259,0.186-1.951,0.167c-0.166-0.004-0.381-0.036-0.462-0.16c-0.13-0.2,0.047-0.632,0.145-0.87 c0.116-0.291,0.145-0.734-0.069-1.021c-0.109-0.146-0.327-0.314-0.728-0.278c-0.973,0.089-1.035,0.911-1.121,2.05 c-0.021,0.271-0.127,0.324-0.162,0.342C4.664,18.568,4,18.3,3.609,18.059c-0.041,0.169-0.093,0.333-0.13,0.503 c0.256,0.143,0.79,0.405,1.266,0.405c0.149,0,0.293-0.026,0.42-0.09c0.18-0.091,0.4-0.295,0.435-0.751 c0.105-1.388,0.229-1.549,0.668-1.589c0.211-0.016,0.264,0.055,0.281,0.078c0.086,0.116,0.073,0.371-0.014,0.587 C6.421,17.48,6.183,18.06,6.456,18.48c0.159,0.245,0.451,0.375,0.867,0.387c0.67,0.02,1.274-0.031,1.886-0.143 c-0.094,0.698-0.164,1.558-0.086,2.313c0.035,0.332-0.006,0.558-0.115,0.638c-0.198,0.146-0.69-0.069-0.874-0.15l-0.109-0.046 c-0.174-0.064-0.382-0.031-0.57,0.096c-0.212,0.142-0.57,0.518-0.598,1.439c-0.023,0.784,0.151,1.303,0.505,1.502 c0.134,0.075,0.411,0.163,0.774-0.072c0.119-0.077,0.35-0.191,0.552-0.114c0.183,0.072,0.325,0.292,0.411,0.635 c0.129,0.518,0.158,1.669,0.119,2.8C9.145,27.771,9.073,27.777,9,27.783c-1.123,0.1-2.412-0.311-2.699-0.623 c-0.318-0.345-0.424-0.941-0.241-1.358c0.085-0.196,0.082-0.414-0.009-0.631c-0.182-0.431-0.675-0.768-0.899-0.853 c-0.156-0.058-0.686-0.227-1.005,0.06c-0.198,0.177-0.25,0.46-0.154,0.842c0.026,0.107,0.081,0.327,0.113,0.5 c-0.232-0.159-0.642-0.517-1.016-0.945c0.023,0.272,0.053,0.542,0.086,0.811C3.454,25.853,3.713,26.063,3.875,26.167z M37.837,24.135c0.365,0.456,0.733,0.676,1.039,0.648c0.465-0.026,0.741-0.47,0.986-0.861c0.113-0.183,0.231-0.372,0.331-0.446 c0.082-0.061,0.12-0.045,0.141-0.038c0.178,0.073,0.418,0.535,0.515,1.184c0.082,0.553-0.031,0.938-0.179,1.073 c-0.061,0.057-0.13,0.072-0.219,0.051c-0.337-0.079-0.881-0.048-1.299,0.309c-0.263,0.224-0.563,0.656-0.508,1.452 c0.041,0.596,0.337,1.065,0.649,1.562c0.187,0.297,0.374,0.601,0.512,0.94c-1.588,1.268-3.206,2.202-3.649,2.303 c-0.406,0.093-0.487,0.032-0.495,0.023c-0.033-0.034-0.093-0.188,0.076-0.895c0.101-0.42-0.066-0.663-0.224-0.794 c-0.599-0.497-2.122-0.132-2.804,0.173c-0.698,0.313-1.331,0.958-1.505,1.534c-0.098,0.326-0.023,0.545,0.056,0.671 c0.148,0.234,0.423,0.34,0.643,0.426c0.034,0.013,0.077,0.029,0.116,0.046c-0.046,0.039-0.117,0.094-0.229,0.167 c-0.915,0.597-2.822,0.983-5.232,1.061c-0.409,0.013-0.838,0.056-1.269,0.11c-0.12-0.29-0.199-0.612-0.22-0.976 c-0.026-0.448,0.114-0.833,0.418-1.145c0.512-0.523,1.392-0.747,1.837-0.721c0.456,0.018,0.919-0.021,1.239-0.377 c0.304-0.339,0.397-0.896,0.285-1.702c-0.093-0.668-0.341-1.07-0.737-1.195c-0.694-0.218-1.489,0.533-1.8,0.867 c-0.055,0.06-0.555,0.58-1.143,0.584c-0.002,0-0.005,0-0.007,0c-0.303,0-0.591-0.141-0.856-0.419 c-0.558-0.584-0.541-1.934-0.482-3.128c0.011,0,0.022,0,0.034,0c2.147,0.022,4.552-0.612,5.336-1.089 c0.554-0.337,0.82-0.682,0.817-1.052c-0.003-0.336-0.235-0.642-0.693-0.91c-0.299-0.175-0.294-0.34-0.292-0.395 c0.01-0.357,0.546-0.87,1.334-1.273c0.799-0.409,1.729-0.516,2.075-0.234c0.046,0.037,0.184,0.149,0.09,0.487 c-0.122,0.443-0.078,0.782,0.133,1.008c0.321,0.343,0.864,0.241,0.954,0.222c1.308-0.436,2.364-0.911,3.255-1.386 C37.113,22.827,37.418,23.612,37.837,24.135z M22.374,22.619c-0.588-0.197-1.174-0.047-1.655,0.423 c-0.288,0.283-0.554,0.387-0.788,0.309c-0.43-0.142-0.752-0.831-0.849-1.438c-0.068-0.432,0.049-0.835,0.322-1.107 c0.266-0.265,0.635-0.372,1.042-0.307c0.351,0.058,1.536,0.2,1.961-0.411c0.219-0.313,0.185-0.726-0.099-1.227 c-0.299-0.528-0.545-1.304-0.727-2.016c1.066-0.037,3.666-0.194,4.653-0.862c0.302-0.204,0.644-0.482,0.604-0.828 c-0.041-0.355-0.432-0.504-0.777-0.636c-0.119-0.045-0.233-0.087-0.313-0.136c-0.103-0.063-0.271-0.226-0.253-0.434 c0.027-0.303,0.442-0.634,1.14-0.907c1.28-0.505,1.693-0.246,1.79-0.155c0.175,0.166,0.107,0.473,0.051,0.641 c-0.138,0.412-0.026,0.659,0.092,0.793c0.338,0.386,1.095,0.302,1.788,0.17c0.396-0.075,1.428-0.345,2.565-0.751 c0.461,0.552,0.843,1.09,0.907,1.472c0.084,0.5,0.054,0.624,0.074,0.624h0.001c-0.026,0.009-0.122,0-0.192-0.006 c-0.383-0.032-1.047,0.019-1.387,0.534c-0.279,0.424-0.262,1.011,0.054,1.747c0.373,0.873,0.893,1.115,1.263,1.166 c0.569,0.081,1.059-0.248,1.236-0.47c0.036-0.045,0.077-0.103,0.123-0.166c0.132-0.185,0.379-0.529,0.558-0.529 c0.099,0,0.207,0.129,0.262,0.206c0.206,0.286,0.396,1.09,0.598,1.943c0.094,0.398,0.197,0.824,0.311,1.251 c-0.88,0.476-1.933,0.955-3.245,1.393c-0.085,0.017-0.351,0.038-0.46-0.082c-0.081-0.087-0.087-0.276-0.016-0.532 c0.157-0.568-0.093-0.875-0.256-1.009c-0.578-0.471-1.754-0.267-2.62,0.176c-0.476,0.244-1.583,0.898-1.605,1.705 c-0.007,0.235,0.081,0.572,0.539,0.84c0.287,0.168,0.445,0.339,0.446,0.482c0.002,0.17-0.209,0.396-0.577,0.62 c-0.697,0.425-2.932,1.018-4.92,1.018c-0.055-0.001-0.109-0.001-0.164-0.001c0.033-0.62,0.058-1.202-0.004-1.622 C23.719,23.642,23.113,22.868,22.374,22.619z M9.589,29.593c0.045-0.377,0.082-0.857,0.107-1.366 c1.194-0.099,3.105-0.243,3.526-0.172c0.474,0.084,0.768,0.227,0.896,0.438c0.099,0.159,0.106,0.378,0.024,0.648 c-0.146,0.48-0.104,0.857,0.122,1.117c0.221,0.252,0.598,0.376,1.162,0.376c0.278,0,0.602-0.029,0.973-0.089 c1.314-0.21,1.634-0.729,1.707-1.021c0.078-0.313-0.052-0.635-0.35-0.862c-0.179-0.136-0.271-0.27-0.262-0.374 c0.012-0.128,0.175-0.279,0.446-0.415c0.575-0.288,3.308-1.128,5.381-1.239c-0.065,1.328-0.073,2.735,0.621,3.462 c0.367,0.384,0.759,0.563,1.229,0.573c0.78-0.006,1.391-0.621,1.505-0.744c0.489-0.525,1.009-0.816,1.283-0.73 c0.244,0.077,0.348,0.471,0.392,0.787c0.09,0.644,0.036,1.08-0.161,1.299c-0.174,0.194-0.471,0.227-0.851,0.212 c-0.523-0.003-1.561,0.203-2.211,0.871c-0.406,0.416-0.595,0.929-0.561,1.523c0.022,0.377,0.108,0.706,0.222,1.012 c-1.761,0.271-3.494,0.785-4.231,1.088c-0.518,0.213-0.799,0.487-0.834,0.818c-0.036,0.334,0.181,0.664,0.644,0.983 c0.107,0.074,0.13,0.122,0.134,0.122c-0.043,0.111-0.547,0.378-1.778,0.451c-1.16,0.072-1.507-0.316-1.588-0.437 c-0.078-0.116-0.092-0.242-0.039-0.354c0.149-0.313,0.178-0.589,0.085-0.821c-0.077-0.195-0.236-0.344-0.46-0.43 c-0.363-0.14-2.527-0.33-4.414-0.207c-0.345,0.021-0.667-0.007-0.976-0.055c-0.358-0.549-0.632-1.086-0.691-1.518 c-0.027-0.197-0.032-0.457,0.098-0.566c0.24-0.201,0.918,0.011,1.282,0.123l0.151,0.047c0.464,0.14,0.845,0.08,1.076-0.16 c0.276-0.287,0.297-0.78,0.062-1.469c-0.219-0.644-0.527-1.023-0.94-1.161c-0.412-0.137-0.885-0.018-1.447,0.365 c-0.051,0.035-0.207,0.143-0.479-0.021C9.956,31.4,9.485,30.464,9.589,29.593z"
        ></path>
        <path
          fill="#bebebe"
          d="M21.213,15.091l-0.017,0.003c0.06,0.437,0.148,0.862,0.262,1.234 C21.301,15.638,21.215,15.103,21.213,15.091z"
        ></path>
      </g>
      <path
        fill="#767676"
        d="M25.116,43.687c-0.133,0-0.256-0.007-0.365-0.021c-0.306-0.042-0.464-0.135-0.481-0.286	c-0.051-0.421,1.125-0.575,1.26-0.591c0.326-0.04,0.639-0.044,0.883-0.011c0.306,0.042,0.464,0.135,0.481,0.286	c0.019,0.15-0.112,0.278-0.4,0.391c-0.228,0.09-0.532,0.161-0.86,0.2C25.453,43.676,25.278,43.687,25.116,43.687z M24.528,43.348	c0.095,0.063,0.488,0.128,1.075,0.059c0.585-0.07,0.953-0.229,1.031-0.313c-0.095-0.063-0.488-0.128-1.076-0.058	C24.974,43.107,24.605,43.265,24.528,43.348z M26.648,43.077L26.648,43.077L26.648,43.077L26.648,43.077z"
      ></path>
    </svg>
  ),
  department: (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3 21.3253H21M3 10.3253H21M5 6.32532L12 3.32532L19 6.32532M4 10.3253V21.3253M20 10.3253V21.3253M8 14.3253V17.3253M12 14.3253V17.3253M16 14.3253V17.3253"
        stroke="#354052"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  navigation: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1222_33856)">
        <path
          d="M7 13.5C10.5899 13.5 13.5 10.5899 13.5 7C13.5 3.41015 10.5899 0.5 7 0.5C3.41015 0.5 0.5 3.41015 0.5 7C0.5 10.5899 3.41015 13.5 7 13.5Z"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.5 10.5L9.5 4.5L3.5 6.5L6 8L7.5 10.5Z"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1222_33856">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  unit_info: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1222_37317)">
        <path
          d="M7 13.5C10.5899 13.5 13.5 10.5899 13.5 7C13.5 3.41015 10.5899 0.5 7 0.5C3.41015 0.5 0.5 3.41015 0.5 7C0.5 10.5899 3.41015 13.5 7 13.5Z"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.5 10H8.5"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7 10V6.5H6"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7 4.25C6.86193 4.25 6.75 4.13807 6.75 4C6.75 3.86193 6.86193 3.75 7 3.75"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7 4.25C7.13807 4.25 7.25 4.13807 7.25 4C7.25 3.86193 7.13807 3.75 7 3.75"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1222_37317">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  info: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 8V9M12 11.5V16M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        stroke="#28303F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  info_black: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM12.75 8C12.75 7.58579 12.4142 7.25 12 7.25C11.5858 7.25 11.25 7.58579 11.25 8V9C11.25 9.41421 11.5858 9.75 12 9.75C12.4142 9.75 12.75 9.41421 12.75 9V8ZM12.75 11.5C12.75 11.0858 12.4142 10.75 12 10.75C11.5858 10.75 11.25 11.0858 11.25 11.5V16C11.25 16.4142 11.5858 16.75 12 16.75C12.4142 16.75 12.75 16.4142 12.75 16V11.5Z"
        fill="#000000"
      />
    </svg>
  ),
  dropDownArrow: (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6 10.3253L12 16.3253L18 10.3253H6Z"
        fill="var(--dark-grey)"
        stroke="var(--dark-grey)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  students: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.238 10.5147V11.5014C20.238 12.7277 19.244 13.7218 18.0177 13.7218C16.7914 13.7218 15.7973 12.7277 15.7973 11.5014V10.5147L17.3414 11.2009C17.7719 11.3923 18.2634 11.3923 18.694 11.2009L20.238 10.5147ZM14.4096 9.89794V12.3341C14.4096 12.5641 14.2232 12.7505 13.9933 12.7505C13.7634 12.7505 13.577 12.5641 13.577 12.3341V9.52734C13.582 9.52995 13.5872 9.53244 13.5925 9.5348L14.4096 9.89794Z"
        fill="black"
      />
      <path
        d="M22.4428 9.43735L18.694 7.77121C18.2635 7.57984 17.772 7.57984 17.3414 7.77121L13.5926 9.43735C13.3728 9.53502 13.3728 9.84692 13.5926 9.9446L17.3414 11.6107C17.772 11.8021 18.2635 11.8021 18.694 11.6107L22.4428 9.9446C22.6626 9.84692 22.6626 9.53502 22.4428 9.43735Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.317 18.5722H21.3483C21.9615 18.5722 22.4585 18.0752 22.4585 17.462C22.4585 16.2591 21.3723 15.2245 19.8152 14.7666C19.6293 14.712 19.4305 14.7707 19.2942 14.9084L18.4125 15.8C18.1952 16.0197 17.8404 16.0197 17.6231 15.8L16.7413 14.9084C16.6051 14.7707 16.4063 14.712 16.2204 14.7666C15.6749 14.927 15.1872 15.1582 14.7838 15.4426C15.745 16.3222 16.3131 17.4032 16.317 18.5722Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.782 8.20718V9.71261C11.782 11.5833 10.2655 13.0998 8.39476 13.0998C6.52405 13.0998 5.00754 11.5833 5.00754 9.71261V8.20718L7.363 9.25406C8.01986 9.546 8.76966 9.546 9.42652 9.25406L11.782 8.20718ZM2.89053 7.26629V10.9828C2.89053 11.3336 2.60618 11.6179 2.25542 11.6179C1.90467 11.6179 1.62032 11.3336 1.62032 10.9828V6.70093C1.62804 6.70491 1.63595 6.7087 1.64406 6.71231L2.89053 7.26629Z"
        fill="black"
      />
      <path
        d="M15.1455 5.93844L9.42659 3.39669C8.76973 3.10475 8.01994 3.10475 7.36307 3.39669L1.64414 5.93844C1.30888 6.08744 1.30888 6.56326 1.64414 6.71226L7.36307 9.25401C8.01994 9.54595 8.76973 9.54595 9.42659 9.25401L15.1455 6.71226C15.4808 6.56326 15.4808 6.08744 15.1455 5.93844Z"
        fill="black"
      />
      <path
        d="M6.44747 14.2851L7.79265 15.6453C8.12409 15.9804 8.66541 15.9804 8.99685 15.6453L10.342 14.2851C10.5498 14.075 10.8532 13.9854 11.1367 14.0688C13.5121 14.7673 15.1692 16.3456 15.1692 18.1807C15.1692 19.1161 14.4109 19.8743 13.4756 19.8743H3.31392C2.37856 19.8743 1.62031 19.1161 1.62031 18.1807C1.62031 16.3456 3.27739 14.7673 5.65279 14.0688C5.93631 13.9854 6.23967 14.075 6.44747 14.2851Z"
        fill="black"
      />
    </svg>
  ),
  menuIcon: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 6H16M10 14H16M10 10H22M10 18H22M4 10C2.89543 10 2 9.10457 2 8C2 6.89543 2.89543 6 4 6C5.10457 6 6 6.89543 6 8C6 9.10457 5.10457 10 4 10ZM4 18C2.89543 18 2 17.1046 2 16C2 14.8954 2.89543 14 4 14C5.10457 14 6 14.8954 6 16C6 17.1046 5.10457 18 4 18Z"
        stroke="#28303F"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  ),
  checkIcon: (
    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM16.592 9.46049C16.8463 9.13353 16.7874 8.66232 16.4605 8.40802C16.1335 8.15372 15.6623 8.21262 15.408 8.53958L11.401 13.6914C11.3119 13.806 11.1443 13.8209 11.0364 13.7238L8.50173 11.4426C8.19385 11.1655 7.71963 11.1904 7.44254 11.4983C7.16544 11.8062 7.1904 12.2804 7.49828 12.5575L10.033 14.8387C10.7881 15.5183 11.9613 15.4143 12.585 14.6123L16.592 9.46049Z"
        fill="var(--explore-color)"
      />
    </svg>
  ),
  global: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.3607 18.0108C20.3607 20.214 18.4891 22 16.1804 22H7.81965C5.5109 22 3.6393 20.214 3.6393 18.0108V13.133C3.6393 12.4248 3.34447 11.7456 2.81969 11.2448C1.60381 10.0845 1.76187 8.16205 3.15251 7.19692L9.54124 2.763C11.0071 1.74567 12.9929 1.74567 14.4588 2.763L20.8475 7.19691C22.2381 8.16205 22.3962 10.0845 21.1803 11.2448C20.6555 11.7456 20.3607 12.4248 20.3607 13.133V18.0108ZM12 18C13.1046 18 14 17.1046 14 16C14 14.8954 13.1046 14 12 14C10.8954 14 10 14.8954 10 16C10 17.1046 10.8954 18 12 18Z"
        fill="var(--explore-color)"
      />
    </svg>
  ),
  global_outlined: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M20.025 18.7711C20.0297 18.7641 20.0367 18.757 20.0414 18.75C21.5766 16.9242 22.5 14.5711 22.5 12C22.5 9.42891 21.5766 7.07578 20.0438 5.25C20.0391 5.24297 20.032 5.23828 20.0273 5.23125C20.0016 5.20078 19.9781 5.17266 19.9523 5.14453C19.943 5.13281 19.9336 5.12344 19.9242 5.11172L19.8281 5.00156L19.8258 4.99922C19.7906 4.95938 19.7531 4.91953 19.718 4.87969L19.7156 4.87734C19.6406 4.79766 19.5656 4.71797 19.4883 4.64062L19.4859 4.63828L19.3734 4.52578L19.3664 4.51875C19.3312 4.48359 19.2961 4.45078 19.2609 4.41797C19.2492 4.40625 19.2375 4.39453 19.2234 4.38281C19.2 4.35938 19.1766 4.33828 19.1531 4.31719C19.1461 4.31016 19.1367 4.30312 19.1297 4.29375C17.2594 2.55937 14.7539 1.5 12 1.5C9.24609 1.5 6.74062 2.55937 4.86797 4.29375C4.86094 4.30078 4.85156 4.30781 4.84453 4.31719C4.82109 4.33828 4.79766 4.36172 4.77422 4.38516C4.7625 4.39688 4.75078 4.40859 4.73672 4.42031C4.70156 4.45313 4.66641 4.48828 4.63125 4.52109L4.62422 4.52812L4.51172 4.64062L4.50937 4.64297C4.43203 4.72031 4.35703 4.8 4.28203 4.87969L4.27969 4.88203C4.24219 4.92188 4.20703 4.96172 4.17188 5.00156L4.16953 5.00391C4.13672 5.03906 4.10391 5.07656 4.07344 5.11406C4.06406 5.12578 4.05469 5.13516 4.04531 5.14688C4.01953 5.175 3.99609 5.20547 3.97031 5.23359C3.96562 5.24063 3.95859 5.24531 3.95391 5.25234C2.42344 7.07578 1.5 9.42891 1.5 12C1.5 14.5711 2.42344 16.9242 3.95625 18.75C3.96094 18.757 3.96797 18.7641 3.97266 18.7711L4.04531 18.8578C4.05469 18.8695 4.06406 18.8789 4.07344 18.8906L4.16953 19.0008C4.16953 19.0031 4.17188 19.0031 4.17188 19.0055C4.20703 19.0453 4.24219 19.0852 4.27969 19.1227L4.28203 19.125C4.35703 19.2047 4.43203 19.2844 4.50703 19.3617L4.50937 19.3641C4.54687 19.4016 4.58203 19.4391 4.61953 19.4742L4.62656 19.4813C4.70391 19.5586 4.78359 19.6336 4.86328 19.7062C6.74062 21.4406 9.24609 22.5 12 22.5C14.7539 22.5 17.2594 21.4406 19.132 19.7062C19.2119 19.6331 19.29 19.558 19.3664 19.4813L19.3734 19.4742C19.4109 19.4367 19.4484 19.4016 19.4836 19.3641L19.4859 19.3617C19.5633 19.2844 19.6383 19.2047 19.7109 19.125L19.7133 19.1227C19.7484 19.0828 19.7859 19.0453 19.8211 19.0055C19.8211 19.0031 19.8234 19.0031 19.8234 19.0008C19.8562 18.9656 19.8891 18.9281 19.9195 18.8906C19.9289 18.8789 19.9383 18.8695 19.9477 18.8578C19.9742 18.8296 19.9999 18.8006 20.025 18.7711ZM20.1211 15.4289C19.7977 16.193 19.3711 16.9008 18.8508 17.543C18.2648 17.0365 17.6241 16.5971 16.9406 16.2328C17.2125 15.1336 17.3813 13.9266 17.4258 12.6562H20.7891C20.7188 13.6148 20.4937 14.5453 20.1211 15.4289ZM20.7891 11.3438H17.4258C17.3813 10.0734 17.2125 8.86641 16.9406 7.76719C17.6273 7.40156 18.2672 6.96094 18.8508 6.45703C19.9818 7.84916 20.6584 9.55485 20.7891 11.3438ZM15.4289 3.87891C16.3594 4.27266 17.2055 4.81641 17.9508 5.50078C17.5178 5.86944 17.0518 6.19739 16.5586 6.48047C16.1906 5.42578 15.7195 4.50938 15.1711 3.77578C15.2578 3.80859 15.3445 3.84375 15.4289 3.87891ZM13.3055 20.2992C13.0898 20.468 12.8742 20.5969 12.6562 20.6836V16.3359C13.5862 16.4008 14.5008 16.6079 15.368 16.95C15.1734 17.5266 14.9484 18.0586 14.6883 18.5391C14.2805 19.2984 13.8023 19.9055 13.3055 20.2992ZM14.6883 5.46094C14.9461 5.94375 15.1734 6.47578 15.368 7.05C14.5008 7.39209 13.5862 7.59918 12.6562 7.66406V3.31875C12.8719 3.40547 13.0898 3.53203 13.3055 3.70312C13.8023 4.09453 14.2805 4.70156 14.6883 5.46094ZM12.6562 15.0211V12.6562H16.1133C16.0758 13.6922 15.9469 14.6977 15.7313 15.6516L15.7242 15.6797C14.7406 15.3067 13.7063 15.0847 12.6562 15.0211ZM12.6562 11.3438V8.97891C13.7297 8.91328 14.7609 8.68594 15.7242 8.32031L15.7313 8.34844C15.9469 9.30234 16.0758 10.3055 16.1133 11.3438H12.6562ZM11.3438 12.6562V15.0211C10.2703 15.0867 9.23906 15.3141 8.27578 15.6797L8.26875 15.6516C8.05312 14.6977 7.92422 13.6945 7.88672 12.6562H11.3438ZM7.88672 11.3438C7.92422 10.3078 8.05312 9.30234 8.26875 8.34844L8.27578 8.32031C9.23906 8.68594 10.268 8.91328 11.3438 8.97891V11.3438H7.88672ZM11.3438 16.3359V20.6813C11.1281 20.5945 10.9102 20.468 10.6945 20.2969C10.1977 19.9055 9.71719 19.2961 9.30938 18.5367C9.05156 18.0539 8.82422 17.5219 8.62969 16.9477C9.50156 16.6055 10.4086 16.4016 11.3438 16.3359ZM11.3438 7.66406C10.4138 7.59918 9.49924 7.39209 8.63203 7.05C8.82656 6.47344 9.05156 5.94141 9.31172 5.46094C9.71953 4.70156 10.1977 4.09219 10.6969 3.70078C10.9125 3.53203 11.1281 3.40313 11.3461 3.31641V7.66406H11.3438ZM8.57109 3.87891C8.65781 3.84375 8.74219 3.80859 8.82891 3.77578C8.28047 4.50938 7.80937 5.42578 7.44141 6.48047C6.94922 6.19922 6.48281 5.87109 6.04922 5.50078C6.79453 4.81641 7.64063 4.27266 8.57109 3.87891ZM3.87891 8.57109C4.20234 7.80703 4.62891 7.09922 5.14922 6.45703C5.73281 6.96094 6.37266 7.40156 7.05938 7.76719C6.7875 8.86641 6.61875 10.0734 6.57422 11.3438H3.21094C3.28125 10.3852 3.50625 9.45469 3.87891 8.57109ZM3.21094 12.6562H6.57422C6.61875 13.9266 6.7875 15.1336 7.05938 16.2328C6.37589 16.5971 5.7352 17.0365 5.14922 17.543C4.01819 16.1508 3.34164 14.4451 3.21094 12.6562ZM8.57109 20.1211C7.64063 19.7273 6.79453 19.1836 6.04922 18.4992C6.48281 18.1289 6.94922 17.8031 7.44141 17.5195C7.80937 18.5742 8.28047 19.4906 8.82891 20.2242C8.74219 20.1914 8.65547 20.1562 8.57109 20.1211ZM15.4289 20.1211C15.3422 20.1562 15.2578 20.1914 15.1711 20.2242C15.7195 19.4906 16.1906 18.5742 16.5586 17.5195C17.0508 17.8008 17.5172 18.1289 17.9508 18.4992C17.2096 19.1807 16.3565 19.7294 15.4289 20.1211Z"
        fill="black"
      />
    </svg>
  ),
  google_scholar: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.84013 5.06253C9.48071 5.96842 9.18818 7.0688 8.99051 8.30415C9.9469 8.21655 10.9574 8.16992 12 8.16992C13.0427 8.16992 14.0531 8.21655 15.0095 8.30415C14.8119 7.0688 14.5193 5.96842 14.1599 5.06253C13.8144 4.19183 13.4221 3.53861 13.0253 3.11559C12.63 2.6942 12.2833 2.55266 12 2.55266C11.7168 2.55266 11.37 2.6942 10.9748 3.11559C10.5779 3.53861 10.1856 4.19183 9.84013 5.06253ZM8.42925 4.49357C7.98078 5.62389 7.63666 6.9855 7.42575 8.49077C6.38755 8.64513 5.44011 8.8511 4.61837 9.09963C3.66224 9.38882 2.83312 9.74837 2.22609 10.1824C2.1494 10.2373 2.0737 10.2952 2.00005 10.3563C2.67009 6.18086 5.85114 2.8536 9.9309 2C9.91066 2.02076 9.89059 2.04175 9.8707 2.06296C9.29791 2.67358 8.81709 3.51604 8.42925 4.49357ZM14.0691 2C14.0894 2.02076 14.1094 2.04175 14.1293 2.06296C14.7021 2.67358 15.183 3.51604 15.5708 4.49357C16.0193 5.62389 16.3634 6.9855 16.5743 8.49077C17.6125 8.64513 18.5599 8.8511 19.3817 9.09963C20.3378 9.38882 21.1669 9.74837 21.774 10.1824C21.8506 10.2373 21.9263 10.2953 22 10.3564C21.33 6.18086 18.1489 2.85359 14.0691 2ZM22 13.6433C21.9264 13.7045 21.8507 13.7624 21.774 13.8173C21.1669 14.2514 20.3378 14.6109 19.3817 14.9001C18.5599 15.1486 17.6125 15.3546 16.5743 15.509C16.3634 17.0142 16.0193 18.3758 15.5708 19.5062C15.183 20.4837 14.7021 21.3262 14.1293 21.9368C14.1093 21.9581 14.0892 21.9792 14.0688 22C18.1488 21.1465 21.3301 17.8191 22 13.6433ZM9.9312 22C9.91086 21.9792 9.89069 21.9581 9.8707 21.9368C9.29791 21.3262 8.81709 20.4837 8.42925 19.5062C7.98078 18.3758 7.63666 17.0142 7.42575 15.509C6.38755 15.3546 5.44011 15.1486 4.61837 14.9001C3.66223 14.6109 2.83312 14.2514 2.22609 13.8173C2.14938 13.7624 2.07367 13.7045 2 13.6433C2.66996 17.8191 5.8512 21.1465 9.9312 22ZM5.05502 13.4327C5.6995 13.6276 6.44103 13.7966 7.25833 13.9322C7.21206 13.304 7.18805 12.6581 7.18805 11.9999C7.18805 11.3416 7.21206 10.6957 7.25833 10.0675C6.44103 10.2031 5.6995 10.3721 5.05502 10.567C4.1779 10.8323 3.52343 11.133 3.10521 11.432C2.66725 11.7452 2.62933 11.9482 2.62933 11.9999C2.62933 12.0515 2.66725 12.2545 3.10521 12.5677C3.52343 12.8668 4.1779 13.1674 5.05502 13.4327ZM8.70762 11.9999C8.70762 12.7365 8.73947 13.4518 8.79938 14.1379C9.79829 14.2411 10.8749 14.2978 12 14.2978C13.1252 14.2978 14.2018 14.2411 15.2007 14.1379C15.2606 13.4518 15.2924 12.7365 15.2924 11.9999C15.2924 11.2633 15.2606 10.5479 15.2007 9.86187C14.2018 9.7586 13.1252 9.7019 12 9.7019C10.8749 9.7019 9.79829 9.7586 8.79938 9.86187C8.73947 10.5479 8.70762 11.2633 8.70762 11.9999ZM9.84013 18.9372C9.48071 18.0313 9.18818 16.9309 8.99051 15.6956C9.9469 15.7832 10.9574 15.8298 12 15.8298C13.0427 15.8298 14.0531 15.7832 15.0095 15.6956C14.8119 16.9309 14.5193 18.0313 14.1599 18.9372C13.8144 19.8079 13.4221 20.4611 13.0253 20.8841C12.63 21.3055 12.2833 21.4471 12 21.4471C11.7168 21.4471 11.37 21.3055 10.9748 20.8841C10.5779 20.4611 10.1856 19.8079 9.84013 18.9372ZM18.945 13.4327C18.3005 13.6276 17.559 13.7966 16.7417 13.9322C16.788 13.304 16.812 12.6581 16.812 11.9999C16.812 11.3416 16.788 10.6957 16.7417 10.0675C17.559 10.2031 18.3005 10.3721 18.945 10.567C19.8221 10.8323 20.4766 11.133 20.8948 11.432C21.3328 11.7452 21.3707 11.9482 21.3707 11.9999C21.3707 12.0515 21.3328 12.2545 20.8948 12.5677C20.4766 12.8668 19.8221 13.1674 18.945 13.4327Z"
        fill="var(--explore-color)"
      />
    </svg>
  ),
  faculty_outline_black: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M20 5V10.5" stroke="black" strokeLinecap="round" />
      <path
        d="M16.5 7V6.5H15.5V7H16.5ZM8.5 7V6.5H7.5V7H8.5ZM12 2L12.1756 1.53184C12.0624 1.48939 11.9376 1.48939 11.8244 1.53184L12 2ZM4 5L3.82444 4.53184C3.62929 4.60502 3.5 4.79158 3.5 5C3.5 5.20842 3.62929 5.39498 3.82444 5.46816L4 5ZM12 8L11.8244 8.46816C11.9376 8.51061 12.0624 8.51061 12.1756 8.46816L12 8ZM20 5L20.1756 5.46816C20.3707 5.39498 20.5 5.20842 20.5 5C20.5 4.79158 20.3707 4.60502 20.1756 4.53184L20 5ZM12.711 17.0059L12.3555 16.6543L12.3555 16.6543L12.711 17.0059ZM14.2996 15.3996L14.6551 15.7512L14.6551 15.7512L14.2996 15.3996ZM15.238 15.1441L15.3791 14.6644L15.3791 14.6644L15.238 15.1441ZM9.70045 15.3996L10.056 15.048L10.056 15.048L9.70045 15.3996ZM11.289 17.0059L11.6445 16.6543L11.6445 16.6543L11.289 17.0059ZM8.762 15.1441L8.62093 14.6644L8.62093 14.6644L8.762 15.1441ZM19.5 22C19.5 22.2761 19.7239 22.5 20 22.5C20.2761 22.5 20.5 22.2761 20.5 22H19.5ZM3.5 22C3.5 22.2761 3.72386 22.5 4 22.5C4.27614 22.5 4.5 22.2761 4.5 22H3.5ZM15.5 7V9H16.5V7H15.5ZM8.5 9V7H7.5V9H8.5ZM12 12.5C10.067 12.5 8.5 10.933 8.5 9H7.5C7.5 11.4853 9.51472 13.5 12 13.5V12.5ZM15.5 9C15.5 10.933 13.933 12.5 12 12.5V13.5C14.4853 13.5 16.5 11.4853 16.5 9H15.5ZM11.8244 1.53184L3.82444 4.53184L4.17556 5.46816L12.1756 2.46816L11.8244 1.53184ZM12.1756 8.46816L20.1756 5.46816L19.8244 4.53184L11.8244 7.53184L12.1756 8.46816ZM11.8244 2.46816L19.8244 5.46816L20.1756 4.53184L12.1756 1.53184L11.8244 2.46816ZM12.1756 7.53184L4.17556 4.53184L3.82444 5.46816L11.8244 8.46816L12.1756 7.53184ZM13.0665 17.3575L14.6551 15.7512L13.944 15.048L12.3555 16.6543L13.0665 17.3575ZM15.0969 15.6238C17.814 16.4228 19.5 18.1619 19.5 20H20.5C20.5 17.5038 18.2723 15.5153 15.3791 14.6644L15.0969 15.6238ZM9.34493 15.7512L10.9335 17.3575L11.6445 16.6543L10.056 15.048L9.34493 15.7512ZM4.5 20C4.5 18.1619 6.18604 16.4228 8.90306 15.6238L8.62093 14.6644C5.72768 15.5153 3.5 17.5038 3.5 20H4.5ZM19.5 20V22H20.5V20H19.5ZM3.5 20V22H4.5V20H3.5ZM10.056 15.048C9.69186 14.6798 9.14631 14.5099 8.62093 14.6644L8.90306 15.6238C9.0473 15.5814 9.21824 15.6231 9.34493 15.7512L10.056 15.048ZM14.6551 15.7512C14.7818 15.6231 14.9527 15.5814 15.0969 15.6238L15.3791 14.6644C14.8537 14.5099 14.3081 14.6798 13.944 15.048L14.6551 15.7512ZM12.3555 16.6543C12.1598 16.8522 11.8402 16.8522 11.6445 16.6543L10.9335 17.3575C11.5206 17.9511 12.4794 17.9511 13.0665 17.3575L12.3555 16.6543Z"
        fill="black"
      />
    </svg>
  ),
  faculty_outline_white: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 5V10.5"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M17 7V6H15V7H17ZM9 7V6H7V7H9ZM12 2L12.3511 1.06367C12.1247 0.978776 11.8753 0.978776 11.6489 1.06367L12 2ZM4 5L3.64888 4.06367C3.25857 4.21003 3 4.58316 3 5C3 5.41684 3.25857 5.78997 3.64888 5.93633L4 5ZM12 8L11.6489 8.93633C11.8753 9.02122 12.1247 9.02122 12.3511 8.93633L12 8ZM20 5L20.3511 5.93633C20.7414 5.78997 21 5.41684 21 5C21 4.58316 20.7414 4.21003 20.3511 4.06367L20 5ZM12.711 17.0059L12 16.3027H12L12.711 17.0059ZM14.2996 15.3996L15.0106 16.1027L15.0106 16.1027L14.2996 15.3996ZM15.238 15.1441L15.5201 14.1848H15.5201L15.238 15.1441ZM9.70045 15.3996L10.4115 14.6964L9.70045 15.3996ZM11.289 17.0059L12 16.3027L11.289 17.0059ZM8.762 15.1441L8.47987 14.1848L8.762 15.1441ZM19 22C19 22.5523 19.4477 23 20 23C20.5523 23 21 22.5523 21 22H19ZM3 22C3 22.5523 3.44772 23 4 23C4.55228 23 5 22.5523 5 22H3ZM15 7V9H17V7H15ZM9 9V7H7V9H9ZM12 12C10.3431 12 9 10.6569 9 9H7C7 11.7614 9.23858 14 12 14V12ZM15 9C15 10.6569 13.6569 12 12 12V14C14.7614 14 17 11.7614 17 9H15ZM11.6489 1.06367L3.64888 4.06367L4.35112 5.93633L12.3511 2.93633L11.6489 1.06367ZM12.3511 8.93633L20.3511 5.93633L19.6489 4.06367L11.6489 7.06367L12.3511 8.93633ZM11.6489 2.93633L19.6489 5.93633L20.3511 4.06367L12.3511 1.06367L11.6489 2.93633ZM12.3511 7.06367L4.35112 4.06367L3.64888 5.93633L11.6489 8.93633L12.3511 7.06367ZM13.4221 17.709L15.0106 16.1027L13.5885 14.6964L12 16.3027L13.4221 17.709ZM14.9559 16.1035C17.5848 16.8766 19 18.491 19 20H21C21 17.1747 18.5015 15.0615 15.5201 14.1848L14.9559 16.1035ZM8.98942 16.1027L10.5779 17.709L12 16.3027L10.4115 14.6964L8.98942 16.1027ZM5 20C5 18.491 6.41522 16.8766 9.04412 16.1035L8.47987 14.1848C5.4985 15.0615 3 17.1747 3 20H5ZM19 20V22H21V20H19ZM3 20V22H5V20H3ZM10.4115 14.6964C9.92868 14.2082 9.19581 13.9742 8.47987 14.1848L9.04412 16.1035C9.02341 16.1096 9.00572 16.1078 8.9964 16.1052C8.9884 16.103 8.98736 16.1007 8.98942 16.1027L10.4115 14.6964ZM15.0106 16.1027C15.0126 16.1007 15.0116 16.103 15.0036 16.1052C14.9943 16.1078 14.9766 16.1096 14.9559 16.1035L15.5201 14.1848C14.8042 13.9742 14.0713 14.2082 13.5885 14.6964L15.0106 16.1027ZM12 16.3027H12L10.5779 17.709C11.3608 18.5006 12.6392 18.5006 13.4221 17.709L12 16.3027Z"
        fill="white"
      />
    </svg>
  ),
  faculty_filled: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5 11.5V6H20V11.5C20 11.9142 19.6642 12.25 19.25 12.25C18.8358 12.25 18.5 11.9142 18.5 11.5Z"
        fill="var(--explore-color)"
      />
      <path
        d="M16 10V7H8V10C8 12.2091 9.79086 14 12 14C14.2091 14 16 12.2091 16 10Z"
        fill="var(--explore-color)"
      />
      <path
        d="M4.02813 5.5431L10.7817 2.54152C11.5574 2.19677 12.4428 2.19677 13.2185 2.54152L19.9721 5.5431C20.368 5.71906 20.368 6.28095 19.9721 6.45691L13.2185 9.45849C12.4428 9.80324 11.5574 9.80324 10.7817 9.45849L4.02813 6.45691C3.63222 6.28095 3.63222 5.71906 4.02813 5.5431Z"
        fill="var(--explore-color)"
      />
      <path
        d="M14.2996 15.3996L12.711 17.0059C12.3196 17.4017 11.6804 17.4017 11.289 17.0059L9.70045 15.3996C9.45505 15.1515 9.09681 15.0457 8.762 15.1442C5.95686 15.9691 4 17.8329 4 20.0001C4 21.1046 4.89543 22.0001 6 22.0001H18C19.1046 22.0001 20 21.1046 20 20.0001C20 17.8329 18.0431 15.9691 15.238 15.1442C14.9032 15.0457 14.5449 15.1515 14.2996 15.3996Z"
        fill="var(--explore-color)"
      />
    </svg>
  ),
  institution_outline_black: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 20V10C9 8.89543 9.89543 8 11 8H13C14.1046 8 15 8.89543 15 10V20M9 20C9 21.1046 9.89543 22 11 22H13C14.1046 22 15 21.1046 15 20M9 20V14C9 12.8954 8.10457 12 7 12H5C3.89543 12 3 12.8954 3 14V20C3 21.1046 3.89543 22 5 22H7C8.10457 22 9 21.1046 9 20ZM15 20V16C15 14.8954 15.8954 14 17 14H19C20.1046 14 21 14.8954 21 16V20C21 21.1046 20.1046 22 19 22H17C15.8954 22 15 21.1046 15 20Z"
        stroke="black"
        strokeWidth="1.5"
      />
      <path
        d="M11.5245 1.96353C11.6741 1.50287 12.3259 1.50287 12.4755 1.96353L12.6324 2.4463C12.6993 2.65232 12.8913 2.7918 13.1079 2.7918H13.6155C14.0999 2.7918 14.3013 3.4116 13.9094 3.6963L13.4988 3.99468C13.3235 4.122 13.2502 4.34768 13.3171 4.5537L13.474 5.03647C13.6237 5.49713 13.0964 5.88019 12.7046 5.59549L12.2939 5.29712C12.1186 5.1698 11.8814 5.1698 11.7061 5.29712L11.2954 5.59549C10.9036 5.88019 10.3763 5.49713 10.526 5.03647L10.6829 4.5537C10.7498 4.34768 10.6765 4.122 10.5012 3.99468L10.0906 3.6963C9.69871 3.4116 9.90009 2.7918 10.3845 2.7918H10.8921C11.1087 2.7918 11.3007 2.65232 11.3676 2.4463L11.5245 1.96353Z"
        fill="black"
      />
    </svg>
  ),
  institution_outline_white: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9 20V10C9 8.89543 9.89543 8 11 8H13C14.1046 8 15 8.89543 15 10V20M9 20C9 21.1046 9.89543 22 11 22H13C14.1046 22 15 21.1046 15 20M9 20V14C9 12.8954 8.10457 12 7 12H5C3.89543 12 3 12.8954 3 14V20C3 21.1046 3.89543 22 5 22H7C8.10457 22 9 21.1046 9 20ZM15 20V16C15 14.8954 15.8954 14 17 14H19C20.1046 14 21 14.8954 21 16V20C21 21.1046 20.1046 22 19 22H17C15.8954 22 15 21.1046 15 20Z"
        stroke="white"
        strokeWidth="2"
      />
      <path
        d="M11.5245 1.96353C11.6741 1.50287 12.3259 1.50287 12.4755 1.96353L12.6324 2.4463C12.6993 2.65232 12.8913 2.7918 13.1079 2.7918H13.6155C14.0999 2.7918 14.3013 3.4116 13.9094 3.6963L13.4988 3.99468C13.3235 4.122 13.2502 4.34768 13.3171 4.5537L13.474 5.03647C13.6237 5.49713 13.0964 5.88019 12.7046 5.59549L12.2939 5.29712C12.1186 5.1698 11.8814 5.1698 11.7061 5.29712L11.2954 5.59549C10.9036 5.88019 10.3763 5.49713 10.526 5.03647L10.6829 4.5537C10.7498 4.34768 10.6765 4.122 10.5012 3.99468L10.0906 3.6963C9.69871 3.4116 9.90009 2.7918 10.3845 2.7918H10.8921C11.1087 2.7918 11.3007 2.65232 11.3676 2.4463L11.5245 1.96353Z"
        fill="white"
      />
    </svg>
  ),
  institution_filled: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.4755 1.96366C12.3259 1.503 11.6741 1.503 11.5245 1.96366L11.3676 2.44643C11.3007 2.65245 11.1087 2.79193 10.8921 2.79193H10.3845C9.90009 2.79193 9.69871 3.41173 10.0906 3.69643L10.5012 3.99481C10.6765 4.12213 10.7498 4.34781 10.6829 4.55383L10.526 5.0366C10.3763 5.49726 10.9036 5.88032 11.2954 5.59562L11.7061 5.29725C11.8814 5.16993 12.1186 5.16993 12.2939 5.29725L12.7046 5.59562C13.0964 5.88032 13.6237 5.49726 13.474 5.0366L13.3171 4.55383C13.2502 4.34781 13.3235 4.12213 13.4988 3.99481L13.9094 3.69643C14.3013 3.41173 14.0999 2.79193 13.6155 2.79193H13.1079C12.8913 2.79193 12.6993 2.65245 12.6324 2.44643L12.4755 1.96366ZM11 8.00013C9.89543 8.00013 9 8.89556 9 10.0001V20.0001C9 21.1047 9.89543 22.0001 11 22.0001H13C14.1046 22.0001 15 21.1047 15 20.0001V10.0001C15 8.89556 14.1046 8.00013 13 8.00013H11ZM18 14.0001C16.8954 14.0001 16 14.8956 16 16.0001V20.0001C16 21.1047 16.8954 22.0001 18 22.0001H20C21.1046 22.0001 22 21.1047 22 20.0001V16.0001C22 14.8956 21.1046 14.0001 20 14.0001H18ZM2 14.0001C2 12.8956 2.89543 12.0001 4 12.0001H6C7.10457 12.0001 8 12.8956 8 14.0001V20.0001C8 21.1047 7.10457 22.0001 6 22.0001H4C2.89543 22.0001 2 21.1047 2 20.0001V14.0001Z"
        fill="var(--explore-color)"
      />
    </svg>
  ),
  institution_filled_white: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.4755 1.96366C12.3259 1.503 11.6741 1.503 11.5245 1.96366L11.3676 2.44643C11.3007 2.65245 11.1087 2.79193 10.8921 2.79193H10.3845C9.90009 2.79193 9.69871 3.41173 10.0906 3.69643L10.5012 3.99481C10.6765 4.12213 10.7498 4.34781 10.6829 4.55383L10.526 5.0366C10.3763 5.49726 10.9036 5.88032 11.2954 5.59562L11.7061 5.29725C11.8814 5.16993 12.1186 5.16993 12.2939 5.29725L12.7046 5.59562C13.0964 5.88032 13.6237 5.49726 13.474 5.0366L13.3171 4.55383C13.2502 4.34781 13.3235 4.12213 13.4988 3.99481L13.9094 3.69643C14.3013 3.41173 14.0999 2.79193 13.6155 2.79193H13.1079C12.8913 2.79193 12.6993 2.65245 12.6324 2.44643L12.4755 1.96366ZM11 8.00013C9.89543 8.00013 9 8.89556 9 10.0001V20.0001C9 21.1047 9.89543 22.0001 11 22.0001H13C14.1046 22.0001 15 21.1047 15 20.0001V10.0001C15 8.89556 14.1046 8.00013 13 8.00013H11ZM18 14.0001C16.8954 14.0001 16 14.8956 16 16.0001V20.0001C16 21.1047 16.8954 22.0001 18 22.0001H20C21.1046 22.0001 22 21.1047 22 20.0001V16.0001C22 14.8956 21.1046 14.0001 20 14.0001H18ZM2 14.0001C2 12.8956 2.89543 12.0001 4 12.0001H6C7.10457 12.0001 8 12.8956 8 14.0001V20.0001C8 21.1047 7.10457 22.0001 6 22.0001H4C2.89543 22.0001 2 21.1047 2 20.0001V14.0001Z"
        fill="white"
      />
    </svg>
  ),
  unit_black: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.3417 15.3416C10.7279 19.9555 5.49154 22.1996 3.64602 20.3541C1.8005 18.5085 4.04463 13.2722 8.65843 8.65838C13.2722 4.04456 18.5086 1.80041 20.3541 3.64594C22.1996 5.49147 19.9555 10.7278 15.3417 15.3416Z"
        stroke="black"
        strokeWidth="2"
      />
      <path
        d="M15.3416 8.65837C19.9554 13.2722 22.1995 18.5085 20.354 20.3541C18.5085 22.1996 13.2721 19.9554 8.65834 15.3416C4.04454 10.7278 1.80041 5.49146 3.64593 3.64593C5.49145 1.8004 10.7278 4.04455 15.3416 8.65837Z"
        stroke="black"
        strokeWidth="2"
      />
      <path
        d="M14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z"
        stroke="black"
        strokeWidth="2"
      />
    </svg>
  ),
  unit_white: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.3417 15.3416C10.7279 19.9555 5.49154 22.1996 3.64602 20.3541C1.8005 18.5085 4.04463 13.2722 8.65843 8.65838C13.2722 4.04456 18.5086 1.80041 20.3541 3.64594C22.1996 5.49147 19.9555 10.7278 15.3417 15.3416Z"
        stroke="white"
        strokeWidth="2"
      />
      <path
        d="M15.3416 8.65837C19.9554 13.2722 22.1995 18.5085 20.354 20.3541C18.5085 22.1996 13.2721 19.9554 8.65834 15.3416C4.04454 10.7278 1.80041 5.49146 3.64593 3.64593C5.49145 1.8004 10.7278 4.04455 15.3416 8.65837Z"
        stroke="white"
        strokeWidth="2"
      />
      <path
        d="M14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z"
        stroke="white"
        strokeWidth="2"
      />
    </svg>
  ),
  unit_fill: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.3417 15.3416C10.7279 19.9555 5.49154 22.1996 3.64602 20.3541C1.8005 18.5085 4.04463 13.2722 8.65843 8.65838C13.2722 4.04456 18.5086 1.80041 20.3541 3.64594C22.1996 5.49147 19.9555 10.7278 15.3417 15.3416Z"
        stroke="var(--explore-color)"
        strokeWidth="2"
      />
      <path
        d="M15.3416 8.65837C19.9554 13.2722 22.1995 18.5085 20.354 20.3541C18.5085 22.1996 13.2721 19.9554 8.65834 15.3416C4.04454 10.7278 1.80041 5.49146 3.64593 3.64593C5.49145 1.8004 10.7278 4.04455 15.3416 8.65837Z"
        stroke="var(--explore-color)"
        strokeWidth="2"
      />
      <path
        d="M14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z"
        stroke="var(--explore-color)"
        strokeWidth="2"
      />
    </svg>
  ),
  venue_outline_black: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14ZM12 14V22M7 6H17C18.1046 6 19 5.10457 19 4C19 2.89543 18.1046 2 17 2H7C5.89543 2 5 2.89543 5 4C5 5.10457 5.89543 6 7 6ZM6.99197 6H17.008L18.7221 11.3282C19.2189 12.5829 19.0429 13.9811 18.2476 15.0968L12.9519 21.526C12.5014 22.158 11.4986 22.158 11.0481 21.526L5.75238 15.0968C4.95707 13.9811 4.78105 12.5829 5.27795 11.3282L6.99197 6Z"
        stroke="black"
        strokeWidth="1.5"
      />
    </svg>
  ),
  venue_outline_white: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14ZM12 14V22M7 6H17C18.1046 6 19 5.10457 19 4C19 2.89543 18.1046 2 17 2H7C5.89543 2 5 2.89543 5 4C5 5.10457 5.89543 6 7 6ZM6.99197 6H17.008L18.7221 11.3282C19.2189 12.5829 19.0429 13.9811 18.2476 15.0968L12.9519 21.526C12.5014 22.158 11.4986 22.158 11.0481 21.526L5.75238 15.0968C4.95707 13.9811 4.78105 12.5829 5.27795 11.3282L6.99197 6Z"
        stroke="white"
        strokeWidth="1.5"
      />
    </svg>
  ),
  venue_filled: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 6H17C18.1046 6 19 5.10457 19 4C19 2.89543 18.1046 2 17 2H7C5.89543 2 5 2.89543 5 4C5 5.10457 5.89543 6 7 6ZM5.27795 11.3282L6.51994 7.46741C6.67688 7.48893 6.83714 7.50006 7 7.50006H17C17.1629 7.50006 17.3231 7.48893 17.4801 7.46741L18.7221 11.3282C19.2189 12.583 19.0429 13.9812 18.2476 15.0969L12.9519 21.5261C12.8931 21.6085 12.825 21.6801 12.75 21.741V13.8546C13.483 13.5579 14 12.8393 14 12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12C10 12.8393 10.517 13.5579 11.25 13.8546V21.741C11.175 21.6801 11.1069 21.6085 11.0481 21.5261L5.75238 15.0969C4.95707 13.9812 4.78105 12.583 5.27795 11.3282Z"
        fill="var(--explore-color)"
      />
    </svg>
  ),
  concept_outline_black: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 18H16M8 18C8 20.2091 9.79086 22 12 22C14.2091 22 16 20.2091 16 18M8 18V15.7887C8 15.1349 7.66659 14.5363 7.19153 14.0871C5.84201 12.8111 5 11.0039 5 9C5 5.13401 8.13401 2 12 2C15.866 2 19 5.13401 19 9C19 11.0039 18.158 12.8111 16.8085 14.0871C16.3334 14.5363 16 15.1349 16 15.7887V18M10 9L12 11M12 11L14 9M12 11V18"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  concept_outline_white: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 18H16M8 18C8 20.2091 9.79086 22 12 22C14.2091 22 16 20.2091 16 18M8 18V15.7887C8 15.1349 7.66659 14.5363 7.19153 14.0871C5.84201 12.8111 5 11.0039 5 9C5 5.13401 8.13401 2 12 2C15.866 2 19 5.13401 19 9C19 11.0039 18.158 12.8111 16.8085 14.0871C16.3334 14.5363 16 15.1349 16 15.7887V18M10 9L12 11M12 11L14 9M12 11V18"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  concept_filled: (
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 18.4585V18.7502C16 21.0513 14.2091 22.9168 12 22.9168C9.79086 22.9168 8 21.0513 8 18.7502V18.4585H11.7893C11.8561 18.4788 11.9268 18.4897 12 18.4897C12.0732 18.4897 12.1439 18.4788 12.2107 18.4585H16ZM16 16.9585V16.4468C16 15.7657 16.3334 15.1422 16.8085 14.6743C18.158 13.345 19 11.4625 19 9.37516C19 5.34809 15.866 2.0835 12 2.0835C8.13401 2.0835 5 5.34809 5 9.37516C5 11.4625 5.84201 13.345 7.19153 14.6743C7.66659 15.1422 8 15.7657 8 16.4468V16.9585H11.25V11.7821L9.46967 9.92759C9.17678 9.62249 9.17678 9.12783 9.46967 8.82274C9.76256 8.51764 10.2374 8.51764 10.5303 8.82274L12 10.3536L13.4697 8.82274C13.7626 8.51764 14.2374 8.51764 14.5303 8.82274C14.8232 9.12783 14.8232 9.62249 14.5303 9.92759L12.75 11.7821V16.9585H16Z"
        fill="var(--explore-color)"
      />
    </svg>
  ),
  unit_faculty_members: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <g clipPath="url(#clip0_428_4743)">
        <path
          d="M8.29871 6.14529V5.47854L8.83455 5.7195C9.32378 5.93951 9.88455 5.93585 10.3709 5.70946L10.9306 5.4489V6.14529C10.9306 6.87204 10.3415 7.4612 9.61464 7.46121C8.88791 7.46121 8.29871 6.87205 8.29871 6.14529Z"
          stroke="currentColor"
          strokeWidth="0.8"
          strokeLinecap="round"
        />
        <path
          d="M12.1852 4.60118L9.99939 3.62971C9.7484 3.51813 9.46178 3.51813 9.21071 3.62971L7.02491 4.60118C6.89677 4.65813 6.89677 4.84 7.02491 4.89694L9.21071 5.86842C9.46178 5.98 9.7484 5.98 9.99939 5.86842L12.1852 4.89694C12.3134 4.84 12.3134 4.65813 12.1852 4.60118Z"
          stroke="currentColor"
          strokeWidth="0.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.31947 8.46097C8.38529 8.43778 8.45277 8.41631 8.52181 8.39667C8.63387 8.3648 8.75369 8.39904 8.83575 8.47935L9.36717 8.99923C9.49815 9.12733 9.71203 9.12733 9.84292 8.99923L10.3743 8.47935C10.4564 8.39904 10.5763 8.3648 10.6883 8.39667C11.6267 8.66365 12.2813 9.26686 12.2813 9.96831C12.2813 10.3258 11.9818 10.6156 11.6123 10.6156H9.0812"
          stroke="currentColor"
          strokeWidth="0.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.04292 5.11824V6.40262"
          stroke="currentColor"
          strokeWidth="0.8"
          strokeLinecap="round"
        />
        <path
          d="M1.94826 4.87426V3.82903L3.20119 4.29597C3.61702 4.45095 4.07476 4.45095 4.4906 4.29597L5.74353 3.82903V4.87426C5.74353 5.92229 4.89393 6.7719 3.84589 6.7719C2.79786 6.7719 1.94826 5.9223 1.94826 4.87426Z"
          stroke="currentColor"
          strokeWidth="0.8"
          strokeLinecap="round"
        />
        <path
          d="M7.62786 2.46972L4.42391 1.04575C4.05592 0.882191 3.63585 0.882191 3.26786 1.04575L0.0639138 2.46972C-0.123905 2.5532 -0.123905 2.81976 0.0639138 2.90324L3.26786 4.32721C3.63585 4.49076 4.05592 4.49076 4.42391 4.32721L7.62786 2.90324C7.81567 2.81976 7.81567 2.5532 7.62786 2.46972Z"
          stroke="currentColor"
          strokeWidth="0.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.71829 8.16609L3.49723 8.92812C3.68916 9.11588 4.00261 9.11588 4.19453 8.92812L4.97348 8.16609C5.09381 8.04837 5.26948 7.99819 5.43365 8.0449C6.80916 8.43623 7.76872 9.3205 7.76872 10.3485C7.76872 10.8726 7.32964 11.2974 6.78801 11.2974H0.903756C0.362132 11.2974 -0.0769501 10.8726 -0.0769501 10.3485C-0.0769501 9.3205 0.882609 8.43623 2.25811 8.0449C2.42229 7.99819 2.59795 8.04837 2.71829 8.16609Z"
          stroke="currentColor"
          strokeWidth="0.8"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0.370789 3.13083V5.28245"
          stroke="currentColor"
          strokeWidth="0.8"
          strokeLinecap="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_428_4743">
          <rect width="12" height="12" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  seniority: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="25"
      viewBox="0 0 26 25"
      fill="none"
      color="#4a6fa5"
    >
      <path
        d="M13 24.5C19.6274 24.5 25 19.1274 25 12.5C25 5.87258 19.6274 0.5 13 0.5C6.37258 0.5 1 5.87258 1 12.5C1 19.1274 6.37258 24.5 13 24.5Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6667 7.16669V13.8334H18.3334"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  unit_publications: (
    <svg
      width="14"
      height="13"
      viewBox="0 0 14 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.2 8.33333H8.8C9.79411 8.33333 10.6 9.15414 10.6 10.1667C10.6 11.1792 9.79411 12 8.8 12H2.2M2.2 8.33333V12M2.2 8.33333H1M2.2 12H1M2.2 1H8.8C9.79411 1 10.6 1.82081 10.6 2.83333C10.6 3.84586 9.79411 4.66667 8.8 4.66667H2.2M2.2 1V4.66667M2.2 1H1M2.2 4.66667H1M11.8 4.66667H5.2C4.20589 4.66667 3.4 5.48748 3.4 6.5C3.4 7.51252 4.20589 8.33333 5.2 8.33333H11.8M11.8 4.66667V8.33333M11.8 4.66667H13M11.8 8.33333H13"
        stroke="currentColor"
        strokeWidth="0.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  information: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1222_37317)">
        <path
          d="M7 13.5C10.5899 13.5 13.5 10.5899 13.5 7C13.5 3.41015 10.5899 0.5 7 0.5C3.41015 0.5 0.5 3.41015 0.5 7C0.5 10.5899 3.41015 13.5 7 13.5Z"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.5 10H8.5"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7 10V6.5H6"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7 4.25C6.86193 4.25 6.75 4.13807 6.75 4C6.75 3.86193 6.86193 3.75 7 3.75"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7 4.25C7.13807 4.25 7.25 4.13807 7.25 4C7.25 3.86193 7.13807 3.75 7 3.75"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1222_37317">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  list: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1624_12)">
        <path
          d="M13.3438 5.11058V1.20673C13.3438 1.07731 13.2923 0.95319 13.2008 0.861676C13.1093 0.770162 12.9852 0.71875 12.8558 0.71875L8.95192 0.71875"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.95192 13.4062H12.8558C12.9852 13.4062 13.1093 13.3548 13.2008 13.2633C13.2923 13.1718 13.3438 13.0477 13.3438 12.9183V9.0144"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0.656295 9.0144V12.9183C0.656295 13.0477 0.707695 13.1718 0.799195 13.2633C0.890695 13.3548 1.0148 13.4062 1.1442 13.4062H5.0481"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.0481 0.71875L1.1442 0.71875C1.0148 0.71875 0.890695 0.770162 0.799195 0.861676C0.707695 0.95319 0.656295 1.07731 0.656295 1.20673V5.11058"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.2083 10.8059H3.7916"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.2083 3.19409L3.7916 3.19409"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.2083 8.90283H5.54159"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.79166 8.90283H4.08337"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.2083 7H5.54159"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.79166 7H4.08337"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.2083 5.09692H5.54159"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.79166 5.09692H4.08337"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1624_12">
          <rect
            width="14"
            height="14"
            fill="white"
            transform="matrix(0 1 -1 0 14 0)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  graph: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1222_37232)">
        <path
          d="M3.53125 7.0271L2.88477 9.5"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.1087 4.5L10.3444 7"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.25 6.25732L7.5 7.5"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.5 4.5H10.5C9.94772 4.5 9.5 4.05228 9.5 3.5V1.5C9.5 0.947715 9.94772 0.5 10.5 0.5H12.5C13.0523 0.5 13.5 0.947715 13.5 1.5V3.5C13.5 4.05228 13.0523 4.5 12.5 4.5Z"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.5 11H8.5C7.94772 11 7.5 10.5523 7.5 10V8C7.5 7.44772 7.94772 7 8.5 7H10.5C11.0523 7 11.5 7.44771 11.5 8V10C11.5 10.5523 11.0523 11 10.5 11Z"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.25 7.0271H3.25C2.69772 7.0271 2.25 6.57938 2.25 6.0271V4.0271C2.25 3.47481 2.69772 3.0271 3.25 3.0271H5.25C5.80228 3.0271 6.25 3.47481 6.25 4.0271V6.0271C6.25 6.57938 5.80228 7.0271 5.25 7.0271Z"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.5 13.5H1.5C0.947715 13.5 0.5 13.0523 0.5 12.5V10.5C0.5 9.94772 0.947715 9.5 1.5 9.5H3.5C4.05228 9.5 4.5 9.94771 4.5 10.5V12.5C4.5 13.0523 4.05228 13.5 3.5 13.5Z"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1222_37232">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  treeMap: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.5 2.5L0.5 11.5C0.5 12.0523 0.947715 12.5 1.5 12.5H12.5C13.0523 12.5 13.5 12.0523 13.5 11.5V2.5C13.5 1.9477 13.0523 1.5 12.5 1.5H1.5C0.947715 1.5 0.5 1.9477 0.5 2.5Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 12.5L4 1.5"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 12.5L7.5 1.5"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 7H13.5"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  facebook: (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_17_61)">
        <path
          d="M24 0C10.7453 0 0 10.7453 0 24C0 35.255 7.74912 44.6995 18.2026 47.2934V31.3344H13.2538V24H18.2026V20.8397C18.2026 12.671 21.8995 8.8848 29.9194 8.8848C31.44 8.8848 34.0637 9.18336 35.137 9.48096V16.129C34.5706 16.0694 33.5866 16.0397 32.3645 16.0397C28.4294 16.0397 26.9088 17.5306 26.9088 21.4061V24H34.7482L33.4013 31.3344H26.9088V47.8243C38.7926 46.3891 48.001 36.2707 48.001 24C48 10.7453 37.2547 0 24 0Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_17_61">
          <rect width="48" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  facebook_color: (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_17_24)">
        <path
          d="M48 24C48 10.7453 37.2547 0 24 0C10.7453 0 0 10.7453 0 24C0 35.255 7.74912 44.6995 18.2026 47.2934V31.3344H13.2538V24H18.2026V20.8397C18.2026 12.671 21.8995 8.8848 29.9194 8.8848C31.44 8.8848 34.0637 9.18336 35.137 9.48096V16.129C34.5706 16.0694 33.5866 16.0397 32.3645 16.0397C28.4294 16.0397 26.9088 17.5306 26.9088 21.4061V24H34.7482L33.4013 31.3344H26.9088V47.8243C38.7926 46.3891 48.001 36.2707 48.001 24H48Z"
          fill="#0866FF"
        />
        <path
          d="M33.4003 31.3344L34.7472 24H26.9078V21.4061C26.9078 17.5306 28.4285 16.0397 32.3635 16.0397C33.5856 16.0397 34.5696 16.0694 35.136 16.129V9.48096C34.0627 9.1824 31.439 8.8848 29.9184 8.8848C21.8986 8.8848 18.2016 12.671 18.2016 20.8397V24H13.2528V31.3344H18.2016V47.2934C20.0582 47.7542 22.0003 48 23.999 48C24.983 48 25.9536 47.9395 26.9069 47.8243V31.3344H33.3994H33.4003Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_17_24">
          <rect width="48" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  google: (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_17_74)">
        <path
          d="M23.9996 19.6363V28.9309H36.916C36.3488 31.9199 34.6468 34.4509 32.0941 36.1527L39.8831 42.1964C44.4213 38.0075 47.0395 31.8547 47.0395 24.5456C47.0395 22.8438 46.8868 21.2073 46.6031 19.6366L23.9996 19.6363Z"
          fill="black"
        />
        <path
          d="M10.5494 28.5681L8.79263 29.9128L2.57434 34.7564C6.52342 42.589 14.6174 48 23.9991 48C30.4789 48 35.9116 45.8618 39.8826 42.1965L32.0936 36.1528C29.9554 37.5928 27.2281 38.4656 23.9991 38.4656C17.7591 38.4656 12.4575 34.2547 10.5592 28.5819L10.5494 28.5681Z"
          fill="black"
        />
        <path
          d="M2.57436 13.2437C0.938084 16.4726 0 20.1163 0 23.9999C0 27.8834 0.938084 31.5271 2.57436 34.7561C2.57436 34.7778 10.5599 28.5597 10.5599 28.5597C10.08 27.1197 9.79624 25.5926 9.79624 23.9996C9.79624 22.4067 10.08 20.8795 10.5599 19.4395L2.57436 13.2437Z"
          fill="black"
        />
        <path
          d="M23.9996 9.55636C27.5342 9.55636 30.676 10.7781 33.1851 13.1345L40.0577 6.2619C35.8904 2.37833 30.4797 0 23.9996 0C14.6179 0 6.52342 5.38908 2.57434 13.2437L10.5597 19.44C12.4578 13.7672 17.7596 9.55636 23.9996 9.55636Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_17_74">
          <rect width="48" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  google_color: (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_17_40)">
        <path
          d="M23.9996 19.6363V28.9309H36.916C36.3488 31.9199 34.6468 34.4509 32.0941 36.1527L39.8831 42.1964C44.4213 38.0075 47.0395 31.8547 47.0395 24.5456C47.0395 22.8438 46.8868 21.2073 46.6031 19.6366L23.9996 19.6363Z"
          fill="#4285F4"
        />
        <path
          d="M10.5494 28.568L8.79263 29.9128L2.57434 34.7564C6.52342 42.589 14.6174 48 23.9991 48C30.4789 48 35.9116 45.8618 39.8826 42.1964L32.0936 36.1528C29.9554 37.5927 27.2281 38.4656 23.9991 38.4656C17.7591 38.4656 12.4575 34.2547 10.5592 28.5819L10.5494 28.568Z"
          fill="#34A853"
        />
        <path
          d="M2.57436 13.2436C0.938084 16.4726 0 20.1163 0 23.9999C0 27.8834 0.938084 31.5271 2.57436 34.7561C2.57436 34.7777 10.5599 28.5597 10.5599 28.5597C10.08 27.1197 9.79624 25.5925 9.79624 23.9996C9.79624 22.4067 10.08 20.8795 10.5599 19.4395L2.57436 13.2436Z"
          fill="#FBBC05"
        />
        <path
          d="M23.9996 9.55636C27.5342 9.55636 30.676 10.7781 33.1851 13.1345L40.0577 6.2619C35.8904 2.37833 30.4797 0 23.9996 0C14.6179 0 6.52342 5.38908 2.57434 13.2437L10.5597 19.44C12.4578 13.7672 17.7596 9.55636 23.9996 9.55636Z"
          fill="#EA4335"
        />
      </g>
      <defs>
        <clipPath id="clip0_17_40">
          <rect width="48" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  linkedin: (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_17_68)">
        <path
          d="M44.4469 0H3.54375C1.58437 0 0 1.54688 0 3.45938V44.5312C0 46.4437 1.58437 48 3.54375 48H44.4469C46.4062 48 48 46.4438 48 44.5406V3.45938C48 1.54688 46.4062 0 44.4469 0ZM14.2406 40.9031H7.11563V17.9906H14.2406V40.9031ZM10.6781 14.8688C8.39062 14.8688 6.54375 13.0219 6.54375 10.7437C6.54375 8.46562 8.39062 6.61875 10.6781 6.61875C12.9563 6.61875 14.8031 8.46562 14.8031 10.7437C14.8031 13.0125 12.9563 14.8688 10.6781 14.8688ZM40.9031 40.9031H33.7875V29.7656C33.7875 27.1125 33.7406 23.6906 30.0844 23.6906C26.3812 23.6906 25.8187 26.5875 25.8187 29.5781V40.9031H18.7125V17.9906H25.5375V21.1219H25.6312C26.5781 19.3219 28.9031 17.4188 32.3625 17.4188C39.5719 17.4188 40.9031 22.1625 40.9031 28.3313V40.9031Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0_17_68">
          <rect width="48" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  linkedin_color: (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_17_32)">
        <path
          d="M44.4567 0H3.54333C2.60358 0 1.70232 0.373315 1.03782 1.03782C0.373315 1.70232 0 2.60358 0 3.54333V44.4567C0 45.3964 0.373315 46.2977 1.03782 46.9622C1.70232 47.6267 2.60358 48 3.54333 48H44.4567C45.3964 48 46.2977 47.6267 46.9622 46.9622C47.6267 46.2977 48 45.3964 48 44.4567V3.54333C48 2.60358 47.6267 1.70232 46.9622 1.03782C46.2977 0.373315 45.3964 0 44.4567 0ZM14.3067 40.89H7.09V17.9667H14.3067V40.89ZM10.6933 14.79C9.87473 14.7854 9.07583 14.5384 8.39747 14.0802C7.71911 13.622 7.19168 12.9731 6.88175 12.2154C6.57183 11.4577 6.4933 10.6252 6.65606 9.82291C6.81883 9.02063 7.2156 8.28455 7.79631 7.70756C8.37702 7.13057 9.11563 6.73853 9.91893 6.58092C10.7222 6.42331 11.5542 6.50719 12.3099 6.82197C13.0656 7.13675 13.7111 7.66833 14.1649 8.34962C14.6188 9.03092 14.8606 9.83138 14.86 10.65C14.8677 11.1981 14.765 11.7421 14.558 12.2496C14.351 12.7571 14.044 13.2178 13.6551 13.6041C13.2663 13.9905 12.8037 14.2946 12.2948 14.4983C11.786 14.702 11.2413 14.8012 10.6933 14.79ZM40.9067 40.91H33.6933V28.3867C33.6933 24.6933 32.1233 23.5533 30.0967 23.5533C27.9567 23.5533 25.8567 25.1667 25.8567 28.48V40.91H18.64V17.9833H25.58V21.16H25.6733C26.37 19.75 28.81 17.34 32.5333 17.34C36.56 17.34 40.91 19.73 40.91 26.73L40.9067 40.91Z"
          fill="#0A66C2"
        />
      </g>
      <defs>
        <clipPath id="clip0_17_32">
          <rect width="48" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  keyHole: (
    <svg
      width="14"
      height="14"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_1222_37379)">
        <path
          d="M7 13.5C10.5899 13.5 13.5 10.5899 13.5 7C13.5 3.41015 10.5899 0.5 7 0.5C3.41015 0.5 0.5 3.41015 0.5 7C0.5 10.5899 3.41015 13.5 7 13.5Z"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7 7.5C7.82843 7.5 8.5 6.82843 8.5 6C8.5 5.17157 7.82843 4.5 7 4.5C6.17157 4.5 5.5 5.17157 5.5 6C5.5 6.82843 6.17157 7.5 7 7.5Z"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7 7.5V9.5"
          stroke="black"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_1222_37379">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  externalLink: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M10.5945 3.75H3.75V20.25H20.25V13.5M11.8815 12.2565L19.737 4.401M14.952 3.8715H20.268V9"
        stroke="black"
      />
    </svg>
  ),
  publications: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="33"
      viewBox="0 0 32 33"
      fill="none"
    >
      <mask
        id="mask0_437_6904"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="32"
        height="33"
      >
        <path d="M32 0.5H0V32.5H32V0.5Z" fill="white" />
      </mask>
      <g mask="url(#mask0_437_6904)">
        <path
          d="M16 31.3571V19.3571C16 18.5993 16.301 17.8726 16.8368 17.3368C17.3727 16.801 18.0994 16.4999 18.8571 16.4999C19.6149 16.4999 20.3416 16.801 20.8774 17.3368C21.4133 17.8726 21.7143 18.5993 21.7143 19.3571V25.6428H26.2857C27.4981 25.6428 28.6608 26.1244 29.5182 26.9818C30.3755 27.8391 30.8571 29.0019 30.8571 30.2142V31.3571"
          stroke="#4A6FA5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.3026 7.57457C11.4534 4.43928 7.63018 2.35646 3.45087 1.66282C3.1665 1.62255 2.87681 1.64324 2.60106 1.72353C2.32529 1.80381 2.06977 1.94185 1.85146 2.12847C1.62923 2.31855 1.45082 2.55452 1.3285 2.82015C1.20617 3.08575 1.14284 3.37473 1.14286 3.66714V19.9649C1.13982 20.4655 1.32229 20.9494 1.65504 21.3232C1.9878 21.6971 2.44726 21.9345 2.94472 21.9895C6.20897 22.4323 9.27857 23.724 11.8589 25.7098"
          stroke="#4A6FA5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M14.3035 13.8906V7.57471"
          stroke="#4A6FA5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.6603 21.9895C26.1577 21.9345 26.6171 21.6971 26.9499 21.3232C27.2827 20.9494 27.4651 20.4655 27.4622 19.9649V3.66714C27.4622 3.37473 27.3988 3.08575 27.2766 2.82015C27.1543 2.55452 26.9758 2.31855 26.7536 2.12847C26.5353 1.94185 26.2798 1.80381 26.0039 1.72353C25.7282 1.64324 25.4386 1.62255 25.154 1.66282C20.9748 2.35646 17.1516 4.43928 14.3024 7.57457"
          stroke="#4A6FA5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  ),
  h_index: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="33"
      viewBox="0 0 32 33"
      fill="none"
    >
      <g clipPath="url(#clip0_437_6925)">
        <mask
          id="mask0_437_6925"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="32"
          height="33"
        >
          <path d="M32 0.5H0V32.5H32V0.5Z" fill="white" />
        </mask>
        <g mask="url(#mask0_437_6925)">
          <path
            d="M16 31.3571C24.2055 31.3571 30.8571 24.7055 30.8571 16.5C30.8571 8.29466 24.2055 1.64288 16 1.64288C7.79466 1.64288 1.14288 8.29466 1.14288 16.5C1.14288 24.7055 7.79466 31.3571 16 31.3571Z"
            stroke="#4A6FA5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M13.3491 17.4475V24.0791H11.6553V9.38049H13.3491V14.7776H13.4927C13.751 14.2082 14.1386 13.7561 14.6553 13.4212C15.1769 13.0814 15.8707 12.9116 16.7367 12.9116C17.4878 12.9116 18.1457 13.0623 18.7104 13.3637C19.275 13.6604 19.7127 14.1173 20.0238 14.7345C20.3395 15.347 20.4975 16.1269 20.4975 17.0743V24.0791H18.8037V17.1891C18.8037 16.3135 18.5763 15.6365 18.1218 15.158C17.6721 14.6747 17.0478 14.4331 16.2486 14.4331C15.6936 14.4331 15.196 14.5503 14.7558 14.7848C14.3204 15.0192 13.9759 15.3613 13.7223 15.8111C13.4735 16.2609 13.3491 16.8063 13.3491 17.4475Z"
            fill="#4A6FA5"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_437_6925">
          <rect
            width="32"
            height="32"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  ),
  i10_index: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="4" x2="20" y1="9" y2="9"></line>
      <line x1="4" x2="20" y1="15" y2="15"></line>
      <line x1="10" x2="8" y1="3" y2="21"></line>
      <line x1="16" x2="14" y1="3" y2="21"></line>
    </svg>
  ),
  citation: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="32"
      height="33"
      viewBox="0 0 32 33"
      fill="none"
      color="#3d3d3d"
    >
      <path
        d="M4.00002 28.5C8.00002 28.5 13.3334 27.1667 13.3334 17.8333V7.16667C13.3334 5.5 12.3254 4.47734 10.6667 4.5H5.33335C3.66669 4.5 2.66669 5.5 2.66669 7.12934V15.1667C2.66669 16.8333 3.66669 17.8333 5.33335 17.8333C6.66669 17.8333 6.66669 17.8333 6.66669 19.1667V20.5C6.66669 21.8333 5.33335 23.1667 4.00002 23.1667C2.66669 23.1667 2.66669 23.1773 2.66669 24.5413V27.1667C2.66669 28.5 2.66669 28.5 4.00002 28.5Z"
        stroke="currentColor"
        strokeWidth="1.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20 28.5C24 28.5 29.3334 27.1667 29.3334 17.8333V7.16667C29.3334 5.5 28.324 4.47734 26.6667 4.5H21.3334C19.6667 4.5 18.6667 5.5 18.6667 7.12934V15.1667C18.6667 16.8333 19.6667 17.8333 21.3334 17.8333H22.3334C22.3334 20.8333 22.6667 23.1667 18.6667 23.1667V27.1667C18.6667 28.5 18.6667 28.5 20 28.5Z"
        stroke="currentColor"
        strokeWidth="1.16667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  grant: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="13"
      height="12"
      viewBox="0 0 13 12"
      fill="none"
      color="currentColor"
    >
      <path
        d="M7.57453 11.26L7.43369 11.2214L3.36786 10.1072L3 10.0064V9.625V6.41667V5.91667H3.5H4.43917H4.52935L4.61385 5.94817L8.00885 7.214L8.01274 7.21546L8.01274 7.21547C8.40393 7.36505 8.66667 7.74282 8.66667 8.16667V8.67932L8.15417 8.66651L8.16667 8.16667L8.15413 8.66651L8.15407 8.66651L8.15387 8.6665L8.15314 8.66648L8.15045 8.66642L8.14026 8.66615L8.10207 8.6651C8.06922 8.66417 8.02225 8.66278 7.96539 8.66093C7.85185 8.65724 7.69807 8.65169 7.53823 8.64425C7.37925 8.63686 7.21032 8.62743 7.06778 8.61579C6.99684 8.61 6.92791 8.6033 6.86788 8.59543C6.81982 8.58913 6.7396 8.57766 6.66748 8.55371L7.57453 11.26ZM7.57453 11.26L7.71401 11.2167L11.1732 10.1434L11.7286 9.97102L11.4749 9.4477C11.3033 9.09377 10.931 8.83333 10.5 8.83333H7.37917C7.11397 8.83333 6.85852 8.79413 6.61561 8.71316L6.61502 8.71296L5.70107 8.40959L5.75384 8.25044L6.66689 8.55351L7.57453 11.26ZM8.83333 8.16667V8.66667H9.33333H10.5C11.1922 8.66667 11.75 9.22448 11.75 9.91667V10.1324L7.57486 11.4371L3.63354 10.3448L3 10.1692V10.8267V11.1667H0.5V5.75H4.55887L8.06694 7.05983C8.06703 7.05987 8.06712 7.0599 8.06721 7.05993C8.52531 7.23185 8.83333 7.67525 8.83333 8.16667ZM2.33333 11H2.83333V10.5V6.41667V5.91667H2.33333H1.16667H0.666667V6.41667V10.5V11H1.16667H2.33333ZM6.33333 2.91667C6.33333 1.58281 7.41614 0.5 8.75 0.5C10.0839 0.5 11.1667 1.58281 11.1667 2.91667C11.1667 4.25052 10.0839 5.33333 8.75 5.33333C7.41614 5.33333 6.33333 4.25052 6.33333 2.91667ZM6.5 2.91667C6.5 4.16114 7.50552 5.16667 8.75 5.16667C9.99448 5.16667 11 4.16114 11 2.91667C11 1.67219 9.99448 0.666667 8.75 0.666667C7.50552 0.666667 6.5 1.67219 6.5 2.91667Z"
        stroke="currentColor"
      />
    </svg>
  ),
  collaborator: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="16"
      viewBox="0 0 18 16"
      color="currentColor"
    >
      <path
        d="M12.7333 6.67497C12.4083 6.99997 11.8667 6.99997 11.5417 6.67497L7.81665 2.9583L1.94165 8.82497L1.39165 8.29997C0.41665 7.32497 0.41665 5.74164 1.39165 4.76664L4.92498 1.2333C5.89998 0.258302 7.48332 0.258302 8.45832 1.2333L12.7333 5.49997C13.0583 5.82497 13.0583 6.34997 12.7333 6.67497ZM13.3167 4.9083C13.9667 5.5583 13.9667 6.61664 13.3167 7.26664C12.2583 8.32497 11.1417 7.44997 10.9583 7.26664L7.82498 4.1333L3.18332 8.77497C2.85832 9.09997 2.85832 9.62497 3.18332 9.94997C3.50832 10.275 4.03332 10.275 4.36665 9.94997L8.21665 6.09997L8.80832 6.69164L4.95832 10.5416C4.63332 10.8666 4.63332 11.3916 4.95832 11.7166C5.28332 12.0416 5.80832 12.0416 6.14165 11.7166L9.99165 7.86664L10.5833 8.4583L6.73332 12.3083C6.40832 12.6333 6.40832 13.1583 6.73332 13.4833C7.05832 13.8083 7.58332 13.8083 7.90832 13.4833L11.7583 9.6333L12.35 10.225L8.49998 14.075C8.17498 14.4 8.17498 14.925 8.49998 15.25C8.82498 15.575 9.34998 15.575 9.67498 15.25L16.6083 8.29997C17.5833 7.32497 17.5833 5.74164 16.6083 4.76664L13.075 1.2333C12.1167 0.274969 10.5667 0.258302 9.59165 1.1833L13.3167 4.9083Z"
        fill="currentColor"
      />
    </svg>
  ),
  score: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526"></path>
      <circle cx="12" cy="8" r="6"></circle>
    </svg>
  ),
  keyword: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <mask id="path-1-inside-1_366_1438" fill="white">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 2.965C0 1.88 0.88 1 1.965 1H4.772C5.857 1 6.737 1.88 6.737 2.965V3.526C6.737 4.612 5.857 5.491 4.772 5.491H1.965C1.44385 5.491 0.944044 5.28397 0.575535 4.91546C0.207026 4.54696 0 4.04715 0 3.526L0 2.965ZM1.965 2.685C1.92823 2.685 1.89182 2.69224 1.85785 2.70631C1.82388 2.72039 1.79301 2.74101 1.76701 2.76701C1.74101 2.79301 1.72039 2.82388 1.70631 2.85785C1.69224 2.89182 1.685 2.92823 1.685 2.965V3.526C1.68487 3.56285 1.69201 3.59937 1.70603 3.63346C1.72004 3.66755 1.74064 3.69853 1.76666 3.72464C1.79267 3.75074 1.82358 3.77146 1.85762 3.78559C1.89165 3.79972 1.92815 3.807 1.965 3.807H4.772C4.80877 3.807 4.84518 3.79976 4.87915 3.78569C4.91312 3.77161 4.94399 3.75099 4.96999 3.72499C4.99599 3.69899 5.01662 3.66812 5.03069 3.63415C5.04476 3.60018 5.052 3.56377 5.052 3.527V2.965C5.052 2.92823 5.04476 2.89182 5.03069 2.85785C5.01662 2.82388 4.99599 2.79301 4.96999 2.76701C4.94399 2.74101 4.91312 2.72039 4.87915 2.70631C4.84518 2.69224 4.80877 2.685 4.772 2.685H1.965ZM8.14 3.246C8.14 2.781 8.517 2.404 8.982 2.404H15.158C15.3813 2.404 15.5955 2.49271 15.7534 2.65062C15.9113 2.80852 16 3.02269 16 3.246C16 3.46931 15.9113 3.68348 15.7534 3.84138C15.5955 3.99929 15.3813 4.088 15.158 4.088H8.982C8.87135 4.08826 8.76174 4.06666 8.65947 4.02444C8.55719 3.98222 8.46427 3.92021 8.38603 3.84197C8.30779 3.76373 8.24578 3.67081 8.20356 3.56853C8.16134 3.46626 8.13974 3.35665 8.14 3.246ZM0.28 8.298C0.28 7.833 0.658 7.456 1.123 7.456H11.79C11.9006 7.456 12.0101 7.47778 12.1122 7.52009C12.2144 7.56241 12.3072 7.62443 12.3854 7.70262C12.4636 7.7808 12.5256 7.87362 12.5679 7.97578C12.6102 8.07794 12.632 8.18743 12.632 8.298C12.632 8.40857 12.6102 8.51806 12.5679 8.62022C12.5256 8.72238 12.4636 8.8152 12.3854 8.89338C12.3072 8.97157 12.2144 9.03359 12.1122 9.07591C12.0101 9.11822 11.9006 9.14 11.79 9.14H1.123C1.01235 9.14026 0.902744 9.11866 0.800469 9.07644C0.698194 9.03422 0.605267 8.97221 0.527028 8.89397C0.448788 8.81573 0.386777 8.72281 0.344556 8.62053C0.302335 8.51826 0.279736 8.40865 0.28 8.298ZM0.28 13.35C0.28 12.886 0.658 12.509 1.123 12.509H14.597C14.7076 12.509 14.8171 12.5308 14.9192 12.5731C15.0214 12.6154 15.1142 12.6774 15.1924 12.7556C15.2706 12.8338 15.3326 12.9266 15.3749 13.0288C15.4172 13.1309 15.439 13.2404 15.439 13.351C15.439 13.4616 15.4172 13.5711 15.3749 13.6732C15.3326 13.7754 15.2706 13.8682 15.1924 13.9464C15.1142 14.0246 15.0214 14.0866 14.9192 14.1289C14.8171 14.1712 14.7076 14.193 14.597 14.193H1.123C1.01235 14.1933 0.902744 14.1717 0.800469 14.1294C0.698194 14.0872 0.605267 14.0252 0.527028 13.947C0.448788 13.8687 0.386777 13.7758 0.344556 13.6735C0.302335 13.5713 0.280736 13.4616 0.281 13.351"
        />
      </mask>
      <path
        d="M0 3.526L-1 3.526L0 3.526ZM1.685 3.526L2.685 3.52957V3.526H1.685ZM1.965 3.807L1.965 2.807L1.96499 2.807L1.965 3.807ZM4.772 3.807V2.807V3.807ZM5.052 3.527L4.052 3.527L5.052 3.527ZM5.052 2.965H4.052H5.052ZM4.772 2.685L4.772 3.685L4.772 2.685ZM8.14 3.246L9.14 3.24838V3.246H8.14ZM16 3.246L17 3.246L16 3.246ZM8.982 4.088L8.982 3.088L8.97962 3.088L8.982 4.088ZM0.28 8.298L1.28 8.30038V8.298H0.28ZM11.79 7.456V8.456H11.79L11.79 7.456ZM11.79 9.14L11.79 8.14H11.79V9.14ZM1.123 9.14L1.123 8.14L1.12062 8.14L1.123 9.14ZM14.597 12.509L14.597 13.509L14.597 13.509L14.597 12.509ZM14.597 14.193L14.597 13.193H14.597V14.193ZM1.123 14.193L1.123 13.193L1.12062 13.193L1.123 14.193ZM1 2.965C1 2.43228 1.43228 2 1.965 2V0C0.327715 0 -1 1.32772 -1 2.965H1ZM1.965 2H4.772V0H1.965V2ZM4.772 2C5.30472 2 5.737 2.43228 5.737 2.965H7.737C7.737 1.32771 6.40928 0 4.772 0V2ZM5.737 2.965V3.526H7.737V2.965H5.737ZM5.737 3.526C5.737 4.05938 5.30505 4.491 4.772 4.491V6.491C6.40895 6.491 7.737 5.16462 7.737 3.526H5.737ZM4.772 4.491H1.965V6.491H4.772V4.491ZM1.965 4.491C1.70907 4.491 1.46361 4.38933 1.28264 4.20836L-0.131572 5.62257C0.424474 6.17862 1.17863 6.491 1.965 6.491V4.491ZM1.28264 4.20836C1.10167 4.02739 1 3.78193 1 3.526L-1 3.526C-1 4.31237 -0.687617 5.06653 -0.131572 5.62257L1.28264 4.20836ZM1 3.526V2.965H-1V3.526H1ZM1.965 1.685C1.7969 1.685 1.63046 1.71811 1.47517 1.78243L2.24053 3.63019C2.15318 3.66638 2.05955 3.685 1.965 3.685V1.685ZM1.47517 1.78243C1.31987 1.84676 1.17876 1.94104 1.0599 2.0599L2.47412 3.47412C2.40726 3.54098 2.32789 3.59401 2.24053 3.63019L1.47517 1.78243ZM1.0599 2.0599C0.941045 2.17876 0.846761 2.31987 0.782434 2.47517L2.63019 3.24053C2.59401 3.32789 2.54097 3.40726 2.47412 3.47412L1.0599 2.0599ZM0.782434 2.47517C0.718109 2.63046 0.685 2.79691 0.685 2.965H2.685C2.685 3.05955 2.66638 3.15318 2.63019 3.24053L0.782434 2.47517ZM0.685 2.965V3.526H2.685V2.965H0.685ZM0.685006 3.52243C0.684405 3.69091 0.71707 3.85784 0.781125 4.01367L2.63093 3.25325C2.66696 3.3409 2.68533 3.4348 2.68499 3.52957L0.685006 3.52243ZM0.781125 4.01367C0.845182 4.16949 0.93937 4.31114 1.05829 4.43048L2.47502 3.01879C2.54191 3.08592 2.5949 3.1656 2.63093 3.25325L0.781125 4.01367ZM1.05829 4.43048C1.17721 4.54982 1.31851 4.64452 1.47411 4.70913L2.24112 2.86205C2.32865 2.8984 2.40813 2.95166 2.47502 3.01879L1.05829 4.43048ZM1.47411 4.70913C1.62971 4.77374 1.79653 4.807 1.96501 4.807L1.96499 2.807C2.05976 2.807 2.15359 2.82571 2.24112 2.86205L1.47411 4.70913ZM1.965 4.807H4.772V2.807H1.965V4.807ZM4.772 4.807C4.94009 4.807 5.10654 4.77389 5.26183 4.70957L4.49647 2.86181C4.58382 2.82562 4.67745 2.807 4.772 2.807L4.772 4.807ZM5.26183 4.70957C5.41713 4.64524 5.55824 4.55095 5.6771 4.4321L4.26288 3.01788C4.32974 2.95103 4.40911 2.89799 4.49647 2.86181L5.26183 4.70957ZM5.6771 4.4321C5.79595 4.31324 5.89024 4.17214 5.95457 4.01683L4.10681 3.25147C4.14299 3.16411 4.19603 3.08474 4.26288 3.01788L5.6771 4.4321ZM5.95457 4.01683C6.01889 3.86154 6.052 3.69509 6.052 3.527L4.052 3.527C4.052 3.43245 4.07062 3.33882 4.10681 3.25147L5.95457 4.01683ZM6.052 3.527V2.965H4.052V3.527H6.052ZM6.052 2.965C6.052 2.79691 6.01889 2.63046 5.95457 2.47517L4.10681 3.24053C4.07062 3.15318 4.052 3.05955 4.052 2.965L6.052 2.965ZM5.95457 2.47517C5.89024 2.31986 5.79595 2.17876 5.6771 2.0599L4.26288 3.47412C4.19603 3.40726 4.14299 3.32789 4.10681 3.24053L5.95457 2.47517ZM5.6771 2.0599C5.55824 1.94105 5.41713 1.84676 5.26183 1.78243L4.49647 3.63019C4.40911 3.59401 4.32974 3.54097 4.26288 3.47412L5.6771 2.0599ZM5.26183 1.78243C5.10654 1.71811 4.94009 1.685 4.772 1.685L4.772 3.685C4.67745 3.685 4.58382 3.66638 4.49647 3.63019L5.26183 1.78243ZM4.772 1.685H1.965V3.685H4.772V1.685ZM9.14 3.246C9.14 3.33328 9.06929 3.404 8.982 3.404V1.404C7.96472 1.404 7.14 2.22872 7.14 3.246H9.14ZM8.982 3.404H15.158V1.404H8.982V3.404ZM15.158 3.404C15.1161 3.404 15.0759 3.38735 15.0463 3.35772L16.4605 1.94351C16.115 1.59807 15.6465 1.404 15.158 1.404V3.404ZM15.0463 3.35772C15.0166 3.32809 15 3.28791 15 3.246L17 3.246C17 2.75747 16.8059 2.28895 16.4605 1.94351L15.0463 3.35772ZM15 3.246C15 3.20409 15.0166 3.16391 15.0463 3.13428L16.4605 4.54849C16.8059 4.20305 17 3.73453 17 3.246L15 3.246ZM15.0463 3.13428C15.0759 3.10465 15.1161 3.088 15.158 3.088V5.088C15.6465 5.088 16.115 4.89393 16.4605 4.54849L15.0463 3.13428ZM15.158 3.088H8.982V5.088H15.158V3.088ZM8.97962 3.088C9.00069 3.08795 9.02157 3.09207 9.04105 3.10011L8.27789 4.94878C8.50192 5.04126 8.74202 5.08857 8.98438 5.088L8.97962 3.088ZM9.04105 3.10011C9.06053 3.10815 9.07823 3.11996 9.09314 3.13487L7.67892 4.54908C7.8503 4.72046 8.05385 4.85629 8.27789 4.94878L9.04105 3.10011ZM9.09314 3.13487C9.10804 3.14977 9.11985 3.16747 9.12789 3.18695L7.27922 3.95011C7.37171 4.17415 7.50754 4.3777 7.67892 4.54908L9.09314 3.13487ZM9.12789 3.18695C9.13593 3.20643 9.14005 3.22731 9.14 3.24838L7.14 3.24362C7.13943 3.48598 7.18674 3.72608 7.27922 3.95011L9.12789 3.18695ZM1.28 8.298C1.28 8.38683 1.20874 8.456 1.123 8.456V6.456C0.107261 6.456 -0.72 7.27917 -0.72 8.298H1.28ZM1.123 8.456H11.79V6.456H1.123V8.456ZM11.79 8.456C11.7693 8.456 11.7487 8.45191 11.7295 8.44397L12.4949 6.59621C12.2714 6.50364 12.0319 6.456 11.79 6.456L11.79 8.456ZM11.7295 8.44397C11.7104 8.43603 11.6929 8.42439 11.6783 8.40972L13.0925 6.99551C12.9214 6.82447 12.7184 6.68878 12.4949 6.59621L11.7295 8.44397ZM11.6783 8.40972C11.6636 8.39505 11.652 8.37763 11.644 8.35846L13.4918 7.5931C13.3992 7.36961 13.2635 7.16655 13.0925 6.99551L11.6783 8.40972ZM11.644 8.35846C11.6361 8.33929 11.632 8.31875 11.632 8.298H13.632C13.632 8.0561 13.5844 7.81658 13.4918 7.5931L11.644 8.35846ZM11.632 8.298C11.632 8.27725 11.6361 8.2567 11.644 8.23754L13.4918 9.0029C13.5844 8.77942 13.632 8.5399 13.632 8.298H11.632ZM11.644 8.23754C11.652 8.21837 11.6636 8.20095 11.6783 8.18628L13.0925 9.60049C13.2635 9.42944 13.3992 9.22638 13.4918 9.0029L11.644 8.23754ZM11.6783 8.18628C11.6929 8.17161 11.7104 8.15997 11.7295 8.15203L12.4949 9.99979C12.7184 9.90722 12.9214 9.77153 13.0925 9.60049L11.6783 8.18628ZM11.7295 8.15203C11.7487 8.14409 11.7693 8.14 11.79 8.14L11.79 10.14C12.0319 10.14 12.2714 10.0924 12.4949 9.99979L11.7295 8.15203ZM11.79 8.14H1.123V10.14H11.79V8.14ZM1.12062 8.14C1.14169 8.13995 1.16257 8.14407 1.18205 8.15211L0.418887 10.0008C0.642916 10.0933 0.883011 10.1406 1.12538 10.14L1.12062 8.14ZM1.18205 8.15211C1.20153 8.16015 1.21923 8.17196 1.23413 8.18687L-0.180079 9.60108C-0.00869555 9.77246 0.194857 9.9083 0.418887 10.0008L1.18205 8.15211ZM1.23413 8.18687C1.24904 8.20177 1.26085 8.21947 1.26889 8.23895L-0.579779 9.00211C-0.487295 9.22614 -0.351462 9.4297 -0.180079 9.60108L1.23413 8.18687ZM1.26889 8.23895C1.2746 8.25277 1.28006 8.27332 1.28 8.30038L-0.719997 8.29562C-0.720589 8.54397 -0.669928 8.78374 -0.579779 9.00211L1.26889 8.23895ZM1.28 13.35C1.28 13.4406 1.20796 13.509 1.123 13.509V11.509C0.108035 11.509 -0.72 12.3314 -0.72 13.35H1.28ZM1.123 13.509H14.597V11.509H1.123V13.509ZM14.597 13.509C14.5762 13.509 14.5557 13.5049 14.5365 13.497L15.3019 11.6492C15.0784 11.5566 14.8389 11.509 14.597 11.509L14.597 13.509ZM14.5365 13.497C14.5174 13.489 14.4999 13.4774 14.4853 13.4627L15.8995 12.0485C15.7284 11.8775 15.5254 11.7418 15.3019 11.6492L14.5365 13.497ZM14.4853 13.4627C14.4706 13.4481 14.459 13.4306 14.451 13.4115L16.2988 12.6461C16.2062 12.4226 16.0705 12.2196 15.8995 12.0485L14.4853 13.4627ZM14.451 13.4115C14.4431 13.3923 14.439 13.3718 14.439 13.351H16.439C16.439 13.1091 16.3914 12.8696 16.2988 12.6461L14.451 13.4115ZM14.439 13.351C14.439 13.3303 14.4431 13.3097 14.451 13.2905L16.2988 14.0559C16.3914 13.8324 16.439 13.5929 16.439 13.351H14.439ZM14.451 13.2905C14.459 13.2714 14.4706 13.2539 14.4853 13.2393L15.8995 14.6535C16.0705 14.4824 16.2062 14.2794 16.2988 14.0559L14.451 13.2905ZM14.4853 13.2393C14.4999 13.2246 14.5174 13.213 14.5365 13.205L15.3019 15.0528C15.5254 14.9602 15.7284 14.8245 15.8995 14.6535L14.4853 13.2393ZM14.5365 13.205C14.5557 13.1971 14.5762 13.193 14.597 13.193L14.597 15.193C14.8389 15.193 15.0784 15.1454 15.3019 15.0528L14.5365 13.205ZM14.597 13.193H1.123V15.193H14.597V13.193ZM1.12062 13.193C1.14169 13.193 1.16257 13.1971 1.18205 13.2051L0.418887 15.0538C0.642921 15.1463 0.883017 15.1936 1.12538 15.193L1.12062 13.193ZM1.18205 13.2051C1.20153 13.2132 1.21923 13.225 1.23413 13.2399L-0.180079 14.6541C-0.00869901 14.8255 0.194853 14.9613 0.418887 15.0538L1.18205 13.2051ZM1.23413 13.2399C1.24904 13.2548 1.26085 13.2725 1.26889 13.2919L-0.579779 14.0551C-0.487294 14.2791 -0.35146 14.4827 -0.180079 14.6541L1.23413 13.2399ZM1.26889 13.2919C1.27693 13.3114 1.28105 13.3323 1.281 13.3534L-0.718997 13.3486C-0.719575 13.591 -0.672263 13.8311 -0.579779 14.0551L1.26889 13.2919Z"
        fill="currentColor"
        mask="url(#path-1-inside-1_366_1438)"
      />
      <path
        d="M14.877 9.13999C14.9876 9.13999 15.0971 9.11822 15.1993 9.0759C15.3014 9.03359 15.3942 8.97156 15.4724 8.89338C15.5506 8.81519 15.6126 8.72237 15.6549 8.62021C15.6973 8.51806 15.719 8.40857 15.719 8.29799C15.719 8.18742 15.6973 8.07793 15.6549 7.97577C15.6126 7.87362 15.5506 7.7808 15.4724 7.70261C15.3942 7.62442 15.3014 7.5624 15.1993 7.52009C15.0971 7.47777 14.9876 7.45599 14.877 7.45599C14.6537 7.45599 14.4396 7.5447 14.2817 7.70261C14.1237 7.86052 14.035 8.07468 14.035 8.29799C14.035 8.52131 14.1237 8.73547 14.2817 8.89338C14.4396 9.05128 14.6537 9.13999 14.877 9.13999Z"
        fill="currentColor"
      />
    </svg>
  ),
  wordcloud: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path d="M6.25 10H13.75V11.25H6.25V10ZM6.25 12.5H11.25V13.75H6.25V12.5Z" />
      <path d="M9.99997 4.375C11.163 4.37623 12.2893 4.78182 13.1861 5.52229C14.0829 6.26275 14.6943 7.29201 14.9156 8.43375L15.0775 9.275L15.9206 9.4275C16.7649 9.58032 17.5215 10.0432 18.0419 10.7253C18.5624 11.4074 18.809 12.2594 18.7335 13.1141C18.6579 13.9687 18.2656 14.7642 17.6336 15.3445C17.0016 15.9247 16.1754 16.2477 15.3175 16.25H4.68435C3.82611 16.2484 2.99948 15.926 2.36686 15.346C1.73423 14.7661 1.34134 13.9705 1.26538 13.1156C1.18941 12.2608 1.43587 11.4084 1.95631 10.726C2.47676 10.0435 3.23358 9.58038 4.0781 9.4275L4.92185 9.275L5.08372 8.43375C5.30569 7.29223 5.91738 6.2633 6.81415 5.52294C7.71093 4.78258 8.83707 4.3768 9.99997 4.375ZM9.99997 3.125C8.54648 3.12656 7.13875 3.63345 6.01792 4.55885C4.89708 5.48425 4.13288 6.77058 3.85622 8.1975C2.70482 8.40594 1.67296 9.03736 0.963332 9.96775C0.253708 10.8981 -0.0823915 12.0602 0.0210536 13.2258C0.124499 14.3913 0.660012 15.476 1.5224 16.2669C2.38479 17.0578 3.51173 17.4976 4.68185 17.5H15.3175C16.4875 17.4975 17.6144 17.0575 18.4766 16.2666C19.3389 15.4757 19.8743 14.391 19.9777 13.2255C20.081 12.06 19.7449 10.8979 19.0353 9.96762C18.3256 9.0373 17.2938 8.40593 16.1425 8.1975C15.8661 6.76942 15.1012 5.48209 13.9791 4.55649C12.857 3.6309 11.4477 3.12477 9.9931 3.125H9.99997Z" />
    </svg>
  ),
  panZoom: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      color="#3498DB"
    >
      <path
        d="M4.26667 13.1667H5.33333C5.52222 13.1667 5.68056 13.2306 5.80833 13.3583C5.93611 13.4861 6 13.6444 6 13.8333C6 14.0222 5.93611 14.1806 5.80833 14.3083C5.68056 14.4361 5.52222 14.5 5.33333 14.5H2.66667C2.47778 14.5 2.31944 14.4361 2.19167 14.3083C2.06389 14.1806 2 14.0222 2 13.8333V11.1667C2 10.9778 2.06389 10.8194 2.19167 10.6917C2.31944 10.5639 2.47778 10.5 2.66667 10.5C2.85556 10.5 3.01389 10.5639 3.14167 10.6917C3.26944 10.8194 3.33333 10.9778 3.33333 11.1667V12.2333L4.93333 10.6333C5.05556 10.5111 5.21111 10.45 5.4 10.45C5.58889 10.45 5.74444 10.5111 5.86667 10.6333C5.98889 10.7556 6.05 10.9111 6.05 11.1C6.05 11.2889 5.98889 11.4444 5.86667 11.5667L4.26667 13.1667ZM12.6667 4.76667L11.0667 6.36667C10.9444 6.48889 10.7889 6.55 10.6 6.55C10.4111 6.55 10.2556 6.48889 10.1333 6.36667C10.0111 6.24444 9.95 6.08889 9.95 5.9C9.95 5.71111 10.0111 5.55556 10.1333 5.43333L11.7333 3.83333H10.6667C10.4778 3.83333 10.3194 3.76944 10.1917 3.64167C10.0639 3.51389 10 3.35556 10 3.16667C10 2.97778 10.0639 2.81944 10.1917 2.69167C10.3194 2.56389 10.4778 2.5 10.6667 2.5H13.3333C13.5222 2.5 13.6806 2.56389 13.8083 2.69167C13.9361 2.81944 14 2.97778 14 3.16667V5.83333C14 6.02222 13.9361 6.18056 13.8083 6.30833C13.6806 6.43611 13.5222 6.5 13.3333 6.5C13.1444 6.5 12.9861 6.43611 12.8583 6.30833C12.7306 6.18056 12.6667 6.02222 12.6667 5.83333V4.76667Z"
        fill="currentColor"
      />
    </svg>
  ),
  sort: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      color="#3D3D3D"
    >
      <path
        d="M11 9H20V11H11V9ZM11 13H18V15H11V13ZM11 5H22V7H11V5ZM11 17H16V19H11V17ZM5 20H7V8H10L6 4L2 8H5V20Z"
        fill="currentColor"
      />
    </svg>
  ),
  bookmark: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="27"
      height="30"
      viewBox="0 0 27 30"
      fill="none"
    >
      <path
        d="M25.5 20.4534V13.7974C25.5 8.07735 25.5 5.22002 23.7427 3.44269C21.9853 1.66669 19.156 1.66669 13.5 1.66669C7.844 1.66669 5.01467 1.66669 3.25733 3.44269C1.5 5.21869 1.5 8.08002 1.5 13.7974V20.4547C1.5 24.5827 1.5 26.648 2.47867 27.5494C2.94533 27.98 3.53467 28.2507 4.16267 28.3227C5.47867 28.4734 7.016 27.1134 10.0893 24.3947C11.4493 23.1934 12.128 22.592 12.9133 22.4347C13.3 22.3547 13.7 22.3547 14.0867 22.4347C14.8733 22.592 15.552 23.1934 16.9107 24.3947C19.984 27.1134 21.5213 28.4734 22.8373 28.3214C23.464 28.2507 24.0547 27.98 24.5213 27.5494C25.5 26.648 25.5 24.5827 25.5 20.4534Z"
        stroke="currentColor"
        strokeWidth="1.5"
      />
      <path
        d="M17.5 7H9.5"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  ),
  delete: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      color="var(--error-color)"
    >
      <path
        d="M10.6667 1.16667V2H14.1667C14.2993 2 14.4265 2.05268 14.5203 2.14645C14.614 2.24021 14.6667 2.36739 14.6667 2.5C14.6667 2.63261 14.614 2.75979 14.5203 2.85355C14.4265 2.94732 14.2993 3 14.1667 3H1.83337C1.70077 3 1.57359 2.94732 1.47982 2.85355C1.38605 2.75979 1.33337 2.63261 1.33337 2.5C1.33337 2.36739 1.38605 2.24021 1.47982 2.14645C1.57359 2.05268 1.70077 2 1.83337 2H5.33337V1.16667C5.33337 0.522667 5.85604 0 6.50004 0H9.50004C10.144 0 10.6667 0.522667 10.6667 1.16667ZM6.33337 1.16667V2H9.66671V1.16667C9.66671 1.12246 9.64915 1.08007 9.61789 1.04882C9.58664 1.01756 9.54424 1 9.50004 1H6.50004C6.45584 1 6.41344 1.01756 6.38219 1.04882C6.35093 1.08007 6.33337 1.12246 6.33337 1.16667ZM3.33137 4.11867C3.32567 4.05284 3.30698 3.9888 3.27638 3.93024C3.24578 3.87168 3.20388 3.81977 3.1531 3.7775C3.10231 3.73523 3.04366 3.70345 2.98052 3.68398C2.91737 3.66452 2.851 3.65777 2.78524 3.66411C2.71947 3.67045 2.65561 3.68977 2.59735 3.72094C2.5391 3.75211 2.48759 3.79452 2.44583 3.84571C2.40406 3.89691 2.37285 3.95587 2.354 4.0192C2.33516 4.08253 2.32905 4.14896 2.33604 4.21467L3.27737 13.9467C3.30553 14.2351 3.44005 14.5028 3.65473 14.6975C3.86941 14.8922 4.14888 15 4.43871 15H11.5614C11.8513 15 12.1309 14.8921 12.3456 14.6972C12.5603 14.5024 12.6947 14.2346 12.7227 13.946L13.6647 4.21467C13.6774 4.08259 13.6372 3.95086 13.5528 3.84847C13.4684 3.74607 13.3468 3.6814 13.2147 3.66867C13.0826 3.65594 12.9509 3.69619 12.8485 3.78059C12.7461 3.86498 12.6814 3.98659 12.6687 4.11867L11.7274 13.8493C11.7234 13.8906 11.7042 13.9289 11.6735 13.9567C11.6428 13.9846 11.6028 14 11.5614 14H4.43871C4.39726 14 4.35728 13.9846 4.32659 13.9567C4.2959 13.9289 4.27669 13.8906 4.27271 13.8493L3.33137 4.11867Z"
        fill="currentColor"
      />
      <path
        d="M6.13731 5.00071C6.20289 4.99683 6.26859 5.00591 6.33066 5.02744C6.39272 5.04896 6.44994 5.08251 6.49904 5.12616C6.54813 5.1698 6.58815 5.2227 6.61679 5.28182C6.64544 5.34094 6.66215 5.40512 6.66598 5.47071L6.99931 11.1374C7.00709 11.2699 6.96191 11.4001 6.8737 11.4993C6.7855 11.5985 6.6615 11.6586 6.52898 11.6664C6.39646 11.6742 6.26627 11.629 6.16707 11.5408C6.06786 11.4526 6.00776 11.3286 5.99998 11.196L5.66664 5.52937C5.66277 5.46379 5.67185 5.39809 5.69337 5.33603C5.7149 5.27396 5.74844 5.21674 5.79209 5.16765C5.83574 5.11855 5.88864 5.07854 5.94776 5.04989C6.00688 5.02125 6.07106 5.00453 6.13664 5.00071H6.13731ZM10.3326 5.52937C10.3404 5.39685 10.2952 5.26667 10.207 5.16746C10.1188 5.06826 9.99483 5.00815 9.86231 5.00037C9.72979 4.99259 9.59961 5.03778 9.5004 5.12598C9.40119 5.21418 9.34109 5.33819 9.33331 5.47071L8.99998 11.1374C8.9922 11.2698 9.03734 11.3999 9.12549 11.499C9.21363 11.5982 9.33755 11.6583 9.46998 11.666C9.60241 11.6738 9.73251 11.6287 9.83165 11.5405C9.93079 11.4524 9.99086 11.3285 9.99864 11.196L10.3326 5.52937Z"
        fill="currentColor"
      />
    </svg>
  ),
  classification: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M16.4784 3.27839C16.2024 3.55439 15.8652 4.00679 15.5304 4.49039C15.1872 4.98599 14.8224 5.55239 14.4912 6.08639C14.1482 6.63731 13.8121 7.19256 13.4832 7.75199L11.5848 5.85359C10.9097 5.1787 9.99418 4.79956 9.03959 4.79956C8.085 4.79956 7.16949 5.1787 6.49439 5.85359L4.19999 8.14799C3.97502 8.37303 3.84864 8.6782 3.84864 8.99639C3.84864 9.31459 3.97502 9.61976 4.19999 9.84479L4.60079 10.2456L2.92679 11.9184C2.75952 12.0856 2.62683 12.284 2.5363 12.5025C2.44577 12.721 2.39917 12.9551 2.39917 13.1916C2.39917 13.4281 2.44577 13.6622 2.5363 13.8807C2.62683 14.0992 2.75952 14.2976 2.92679 14.4648L9.53519 21.072C9.87269 21.4091 10.3302 21.5984 10.8072 21.5984C11.2842 21.5984 11.7417 21.4091 12.0792 21.072L13.7532 19.3992L14.1516 19.7964C14.3766 20.0214 14.6818 20.1477 15 20.1477C15.3182 20.1477 15.6234 20.0214 15.8484 19.7964L18.1428 17.502C18.8177 16.8269 19.1968 15.9114 19.1968 14.9568C19.1968 14.0022 18.8177 13.0867 18.1428 12.4116L16.2468 10.5156C16.8074 10.1877 17.3634 9.85203 17.9148 9.50879C18.4476 9.17759 19.014 8.81279 19.5096 8.47079C19.9944 8.13479 20.4456 7.79879 20.7216 7.52159C21.0002 7.24298 21.2212 6.91222 21.372 6.54819C21.5228 6.18417 21.6004 5.79401 21.6004 5.39999C21.6004 5.00598 21.5228 4.61582 21.372 4.25179C21.2212 3.88777 21.0002 3.55701 20.7216 3.27839C20.443 2.99978 20.1122 2.77877 19.7482 2.62799C19.3842 2.4772 18.994 2.3996 18.6 2.3996C17.8042 2.3996 17.0411 2.71571 16.4784 3.27839ZM12.9048 18.5496L11.232 20.2236C11.1195 20.3361 10.9669 20.3993 10.8078 20.3993C10.6487 20.3993 10.4961 20.3361 10.3836 20.2236L3.77519 13.6164C3.6627 13.5039 3.59951 13.3513 3.59951 13.1922C3.59951 13.0331 3.6627 12.8805 3.77519 12.768L5.44919 11.094L12.9048 18.5496ZM15.3708 9.63959L14.3604 8.62919L14.4132 8.53919C14.7697 7.92734 15.1353 7.32087 15.51 6.71999C15.8364 6.19559 16.1892 5.64719 16.5168 5.17319C16.8504 4.68959 17.1348 4.31879 17.328 4.12679C17.4941 3.95495 17.6928 3.81792 17.9124 3.72369C18.1321 3.62946 18.3683 3.57992 18.6073 3.57795C18.8463 3.57599 19.0833 3.62165 19.3045 3.71226C19.5257 3.80286 19.7266 3.93661 19.8955 4.1057C20.0644 4.27479 20.198 4.47582 20.2884 4.69708C20.3788 4.91833 20.4242 5.15538 20.422 5.39438C20.4198 5.63338 20.3701 5.86955 20.2756 6.08911C20.1812 6.30867 20.044 6.50723 19.872 6.67319C19.68 6.86519 19.3104 7.14959 18.8268 7.48319C18.3528 7.81079 17.8044 8.16359 17.28 8.49119C16.6787 8.86489 16.0723 9.23013 15.4608 9.58679L15.3708 9.63959Z"
        fill="currentColor"
      />
    </svg>
  ),
};
